export default {
  common: { loading: 'A carregar…', noData: 'Sem dados', clear: 'Limpar', delete: 'Eliminar' },
  errors: { /* notices-i18n */
    generic: 'Algo correu mal. Tentar novamente.',    codes: {
      // The clock card's refusals (time-api /timer/start and /timer/stop): the card
      // shows the specific reason, as time-ui's own clock button does (issue 700).
      leave_day: 'Este dia tem uma ausência aprovada de dia inteiro — não é possível registar tempo de trabalho.',
      // A person her contract frees from booking working time (issue 981): time-api refuses the clock-in with this code.
      work_time_booking_off: 'Pelo contrato, regista-se apenas tempo de projeto, não tempo de trabalho.',
      week_approved: 'Esta semana já está aprovada e bloqueada – alterações só com um pedido de correção.',
      week_submitted: 'Esta semana foi enviada e aguarda decisão – alterações só depois de ser retirada ou devolvida.',
      already_clocked_in: 'A entrada já foi registada. Encerrar primeiro o tempo de trabalho em curso.',
      block_overlap: 'Este tempo de trabalho sobrepõe-se a outro.',
      block_locked: 'Este tempo de trabalho está bloqueado por uma semana encerrada. Solicitar uma correção em alternativa.',
      // user-api's SSO connection PUT (#882): issuer and client are frozen while SSO is enforced.
      sso_enforced: 'Desative «Exigir início de sessão apenas via SSO» antes de alterar o URL do emissor ou o Client ID.',
      // The SSO connection PUT of user-api (issue 926): a list entry that is not a domain.
      invalid_domain: 'Um dos domínios de e-mail não é um domínio. Introduza domínios como example.com, sem caracteres universais nem endereços web.',
      // ats-api reports this flat on the envelope; `errorKeyFor` prefers a
      // curated code entry over the status fallback, which is how the custom-field
      // dialog keeps its one specific message without reading the backend string.
      CUSTOM_FIELD_SENSITIVITY_LOCKED: 'Este campo está declarado como categoria especial e a declaração não pode ser retirada.',
      LEGAL_NOTICE_BLANK_EMPTY: 'Um campo não pode ser preenchido com nada.',
      LEGAL_NOTICE_BLANK_UNKNOWN: 'Este aviso não tem nenhum campo com esse nome.',
      LEGAL_NOTICE_BLANK_TOKEN: 'Um valor não pode conter, ele próprio, um campo por preencher.',
      // The employee-notice gate (issue 576 M3): the invite refusal names WHO
      // can clear it, so an admin sent here knows the fix is not theirs to retry.
      EMPLOYEE_NOTICE_INCOMPLETE: 'Os convites estão em pausa até que todos os campos dos avisos para colaboradores em Avisos legais sejam preenchidos. Peça ao proprietário do workspace, a uma administração de suite ou ao encarregado de proteção de dados para os completar.',
      LEGAL_READINESS_UNAVAILABLE: 'Não foi possível verificar se os avisos para colaboradores estão completos. Tente novamente dentro de alguns minutos.',
    } as Record<string, string>,
  },
  billing: {
    title: 'Faturação', status: 'Estado', paymentMethod: 'Método de pagamento',
    updateCard: 'Substituir cartão', addCard: 'Adicionar cartão',
    invoices: 'Faturas', charges: 'Pagamentos',
    noInvoices: 'Ainda não há faturas.', noCharges: 'Ainda não há pagamentos.',
    noCard: 'Nenhum registado', validUntil: 'válido até {date}',
    trialDaysLeft: 'Faltam {days} dias de teste', trialExpired: 'Período de teste expirado',
    trialDaysLeftUntil: 'Faltam {days} dias de teste — termina em {date}',
    // A free_months promo account (issue 808): the whole cardless run, never "trial end" at d2.
    trialDaysLeftFree: 'Faltam {days} dias grátis — até {date}',
    nextChargeOn: 'Próxima cobrança em {date}',
    exempt: { badge: 'Isento de faturação', note: 'A lumi definiu que este espaço de trabalho não está a ser faturado atualmente.' },
    download: 'Transferir', dangerZone: 'Zona de perigo',
    col: { date: 'Data', period: 'Período', net: 'Líquido', vat: 'IVA', gross: 'Bruto', status: 'Estado', kind: 'Tipo', amount: 'Montante', document: 'Fatura' },
    statusLabel: { trialing: 'Teste', active: 'Ativo', delinquent: 'Pagamento em falta', closed: 'Encerrado', canceled: 'Cancelado' },
    tab: { plans: 'Planos', paymentMethod: 'Método de pagamento', invoices: 'Faturas e pagamentos', referral: 'Indicações', externalPostings: 'Anúncios de emprego', dangerZone: 'Cancelar e eliminar' },
    externalPostings: {
      title: 'Anúncios em portais de emprego externos',
      intro: 'Os anúncios em portais de emprego externos são encomendados um a um e faturados por encomenda — até vários milhares de euros cada. Com esta opção ativa, pode fazer essas encomendas quem tiver na sua função de recrutamento a permissão «Publicar externamente (pago)» — de início, só os administradores do recrutamento; cada encomenda é faturada a este espaço de trabalho.',
      switchLabel: 'Permitir encomendar anúncios em portais de emprego externos',
      saving: 'A guardar',
      offHint: 'Desativar apenas trava novas encomendas. Os anúncios já publicados continuam online e continuam a ser faturados até ao fim do seu prazo.',
      offHintOpenOrders: 'Existem anúncios publicados neste momento. Desativar apenas trava novas encomendas — os anúncios em curso continuam online e continuam a ser faturados até ao fim do seu prazo.',
      roleNote: 'Só o proprietário do espaço de trabalho, um gestor de faturação ou um administrador da suite podem alterar esta definição. Quem não deva encomendar anúncios é travado do lado do recrutamento, retirando da sua função a permissão «Publicar externamente (pago)».',
      demoNote: 'Este é um espaço de trabalho de demonstração. As definições são substituídas na configuração real, pelo que este comutador fica bloqueado até lá.',
      noCardTitle: 'Sem método de pagamento registado',
      noCardBody: 'É possível ativar esta opção já, mas uma encomenda de anúncio só pode ser paga depois de haver um cartão registado.',
      noCardCta: 'Adicionar cartão',
      savedOn: 'Os anúncios externos estão ativos. Os recrutadores verão a secção de encomenda no próximo carregamento da página.',
      savedOff: 'Os anúncios externos estão desativados. Não é possível encomendar novos anúncios; os que já estão publicados continuam online e continuam a ser faturados.',
    },
    invoiceStatus: { draft: 'Em preparação', issued: 'Emitida', sent: 'Enviada', canceled: 'Anulada' },
    chargeKind: { subscription: 'Subscrição', proration: 'Valor proporcional', posting: 'Anúncio de emprego', recovery: 'Pagamento de recuperação' },
    posting: { orderRef: 'Encomenda {ref}', invoice: 'Descarregar fatura' },
    chargeStatus: { created: 'Criado', pending: 'Pendente', paid: 'Pago', failed: 'Falhou', authorized: 'Reservado', order_placed: 'Submetido', capture_requested: 'Cobrança solicitada', captured: 'Pago', settled: 'Pago', refunded: 'Reembolsado', chargeback: 'Estorno', voided: 'Falhou' },
    bill: { label: 'Fatura {number}', labelMany: 'Faturas {number}', unnumbered: 'Fatura em preparação', paid: 'Paga', closed: 'Fechada', retry: 'Nova tentativa', projected: 'Prevista' },
    // The promo (issue 808, ADR 0100): one line for the phase the account is in.
    promo: { trial: 'Teste até {start} · depois, 1 mês grátis até {end} · código {code} | Teste até {start} · depois, {n} meses grátis até {end} · código {code}', run: 'Meses grátis até {end} · código {code}', discount: 'Teste até {start} · depois, 1 mês com {percent} % de desconto em vagas e módulos · código {code} | Teste até {start} · depois, {n} meses com {percent} % de desconto em vagas e módulos · código {code}', discountRun: '{percent} % de desconto em vagas e módulos até {end} · código {code}', invoiceLine: 'Código promocional {code} −{percent} %', referralLine: 'Bónus de indicação −{percent} %', referralLineCapped: 'Bónus de indicação −{percent} % (com limite)' },
    // A module code typed in the add-module dialog (issue 1029, M2).
    modulePromo: { label: 'Código promocional (opcional)', apply: 'Aplicar', remove: 'Remover', applied: '{code}: {percent} % de desconto em {module} durante 1 fatura | {code}: {percent} % de desconto em {module} durante {n} faturas', savesToday: 'O código desconta {amount} da cobrança de hoje.', rateLimited: 'Demasiadas tentativas. Aguarde alguns minutos e tente novamente.', checkFailed: 'Neste momento não é possível verificar o código. Pode adicionar o módulo sem ele.', notBooked: 'Nada foi contratado – pode adicionar o módulo sem o código.', addedWithoutDiscount: 'Não foi possível aplicar o código, por isso não há desconto.', module: { time_tracking: 'Registo de tempos' }, trimmed: '{code} dá {percent} %, mas a sua fatura já tem um desconto – em {module} recebe {effective} % (todos os descontos de uma fatura têm um limite).', trimmedNothing: '{code} dá {percent} %, mas a sua fatura já tem um desconto – este código não acrescenta nada neste momento.', pending: 'Ainda estamos a confirmar o seu código – aparecerá na sua próxima fatura depois de confirmado.', invoiceLine: 'Código promocional {code} −{percent} % ({module})', running: '{code}: {percent} % de desconto em mais 1 fatura | {code}: {percent} % de desconto em mais {n} faturas', reason: { unknown: 'Não conhecemos este código. Verifique como está escrito.', disabled: 'Este código foi desativado.', notYetValid: 'Este código ainda não é válido.', expired: 'Este código expirou.', exhausted: 'Já utilizou este código, ou ele está esgotado.', moduleNotEligible: 'Este código não abrange {module}.', wrongCheckout: 'Este código é para novos registos, não para adicionar um módulo.', unavailable: 'Este código não pode ser usado aqui.' } },
    // The billing door (issue 824): a promo code entered on a running workspace.
    // The workspace's own referral code (issue 824), shown to those who manage billing.
    referral: { title: 'O seu código de indicação', copy: 'Copiar código', copyLink: 'Copiar link do checkout', copied: 'Código de indicação copiado', linkCopied: 'Link do checkout copiado', friendGets: 'Quem usar o seu código recebe {percent} % de desconto no primeiro mês pago. | Quem usar o seu código recebe {percent} % de desconto nos primeiros {n} meses pagos.', youGet: 'Por cada empresa que começa a pagar com o seu código: {percent} % de desconto numa das suas faturas — vários somam-se, até {ceiling} % por fatura. | Por cada empresa que começa a pagar com o seu código: {percent} % de desconto em {n} das suas faturas — vários somam-se, até {ceiling} % por fatura.', youGetCapped: 'Por cada empresa que começa a pagar com o seu código: {percent} % de desconto numa das suas faturas — vários somam-se, até {ceiling} % por fatura; cada bónus desconta no máximo {cap} por fatura. | Por cada empresa que começa a pagar com o seu código: {percent} % de desconto em {n} das suas faturas — vários somam-se, até {ceiling} % por fatura; cada bónus desconta no máximo {cap} por fatura.', paused: 'O seu código está em pausa enquanto houver um pedido de eliminação aberto para o seu espaço de trabalho. Volta a funcionar assim que for retirado.', disabled: 'Este código foi desativado e já não pode ser usado.', none: { trialing: 'Receberá um código de indicação quando o seu espaço de trabalho começar a pagar, depois do teste.', free_run: 'Receberá um código de indicação quando os meses grátis terminarem e o seu espaço de trabalho começar a pagar.', not_billing: 'Receberá um código de indicação quando o seu espaço de trabalho tiver uma subscrição em curso.' }, loading: 'A carregar o seu código de indicação …', error: 'Não foi possível ler o seu código de indicação neste momento. Tente novamente mais tarde.', bonus: { title: 'Os seus bónus de indicação', collect: 'Resgatar', ready: 'pronto a resgatar', startsOn: 'a partir da sua fatura de {date}', startsNext: 'a partir da sua próxima fatura', waits: 'aguarda espaço numa próxima fatura', carries: 'A sua próxima fatura inclui {items}.', capped: 'com limite', running: { promo: '{percent} % de código promocional', module: '{percent} % de código de módulo', referral: '{percent} % de bónus de indicação' }, collected: 'Resgatado — o bónus passa agora a ser descontado nas suas próximas faturas.', alreadyRunning: 'Este bónus já está em curso.', collectFailed: 'Não foi possível resgatar o bónus neste momento. Tente novamente.', hint: { ceiling: 'Ainda não: a sua próxima fatura já inclui {running} e, com este bónus, ultrapassaria o limite de {ceiling} %.', ceilingRunning: 'Ainda não: a sua próxima fatura já inclui {running}, o que não deixa espaço para este bónus.', ceilingLimit: 'Ainda não: com este bónus, a sua próxima fatura ultrapassaria o limite de {ceiling} %.', ceilingPlain: 'Ainda não: os descontos da sua próxima fatura não deixam espaço para este bónus.', roomNext: 'Um bónus em curso termina com a sua próxima fatura.', roomLater: 'O primeiro bónus em curso termina daqui a {n} faturas.', notActive: 'Este bónus aguarda até o seu espaço de trabalho voltar a estar ativo.', deletion: 'Este bónus aguarda enquanto houver um pedido de eliminação aberto para o seu espaço de trabalho.', unavailable: 'Neste momento não é possível verificar se este bónus pode ser resgatado. Tente novamente daqui a pouco.' } }, history: { title: 'As suas indicações', empty: 'Ainda ninguém usou o seu código.', waiting: 'Usado em {date} — a aguardar o primeiro mês pago', bonusEarned: 'Obtido em {date}: {percent} % de desconto em 1 fatura | Obtido em {date}: {percent} % de desconto em {n} faturas', bonusCap: ', limitado a {cap} por fatura', bonusOn: 'na sua fatura de {months} | nas suas faturas de {months}', bonusToCome: 'faltam {n}', bonusNone: 'ainda em nenhuma fatura' } },
    errors: { setupFailed: 'Falha na configuração do cartão.', loadFailed: 'Não foi possível carregar os dados de faturação.', ownerOnly: 'Apenas o proprietário do espaço de trabalho pode gerir a faturação.', planChangeFailed: 'Não foi possível alterar o plano. Tentar novamente.', paymentStanding: 'Regularizar o pagamento pendente antes de fazer o upgrade.', cardRequired: 'Adicionar um cartão válido antes de fazer o upgrade.', addModuleFailed: 'Não foi possível adicionar o módulo. Tentar novamente.', cancellationPending: 'A subscrição vai terminar. Escolher primeiro «Manter subscrição» e depois adicionar o módulo.', removeFailed: 'Não foi possível agendar a remoção. Tentar novamente.' },
    retry: 'Tentar novamente',
    common: { close: 'Fechar' },
    card: {
      label: 'Cartão', title: 'Método de pagamento',
      remove: 'Remover cartão', removed: 'Cartão removido.',
      inUse: 'Este cartão já foi faturado e só pode ser substituído, não removido.',
      removeConfirmTitle: 'Remover cartão?', removeConfirmBody: 'Isto remove o cartão registado. É possível adicionar um novo em qualquer momento.',
      removeError: 'Não foi possível remover o cartão.',
      handoff: 'Enviar um link de pagamento a outra pessoa', handoffTitle: 'Link de pagamento',
      handoffHint: '«Adicionar/substituir cartão»: os dados do cartão são inseridos diretamente. «Enviar um link de pagamento a outra pessoa»: enviar um link de utilização única a quem configura o cartão — por ex. o departamento de contabilidade.',
      handoffBody: 'Partilhar este link de utilização única com quem configurar o cartão. Expira a {date}.',
      copy: 'Copiar', copied: 'Copiado', handoffCopied: 'Link de pagamento copiado', handoffError: 'Não foi possível criar um link de pagamento.',
    },
    recovery: {
      title: 'Pagamento pendente · {amount}',
      body: 'O banco precisa de confirmar este pagamento. Confirme-o agora para manter o acesso.',
      cta: 'Confirmar pagamento',
      paid: 'Pagamento recebido – o acesso foi restabelecido.',
      failed: 'O pagamento não foi concluído. Pode tentar novamente a qualquer momento.',
      checking: 'Ainda estamos a verificar o pagamento…',
      startError: 'Não foi possível iniciar o pagamento neste momento. Tente novamente dentro de instantes.',
    },
    plan: {
      title: 'Plano e módulos', subtitle: 'Gerir o plano de cada módulo ativo.',
      currentPlan: 'Plano atual', current: 'Atual',
      perMonth: '{amount}/mês', perUserMonth: '{amount} por utilizador/mês', perApprenticeMonth: '{amount} por formando/mês', volumeHint: 'Desconto de volume: workspaces maiores pagam automaticamente menos por lugar.',
      perUpgradeMonth: '{amount} por extensão/mês',
      upgrade: 'Fazer upgrade', downgrade: 'Fazer downgrade', apply: 'Alterar plano',
      downgradeNote: 'Os downgrades entram em vigor no início do próximo ciclo de faturação.',
      fixCardCta: 'Corrigir método de pagamento',
      enterprise: { title: 'Precisa de mais?', body: 'As equipas maiores e as condições personalizadas são acordadas com a nossa equipa.', cta: 'Contactar vendas' },
      provisioning: 'A configurar — pode demorar um minuto.',
      provisioningFailed: 'A configuração falhou — estamos a tratar do assunto.',
      removeModule: 'Remover módulo', removeConfirmTitle: 'Remover o módulo?',
      removeConfirmBody: '{module} será removido no final do ciclo de faturação atual. Até lá, é possível anular esta ação.',
      removeScheduled: 'Remoção de {module} agendada.',
      addTitle: 'Adicionar um módulo', addSubtitle: 'Ampliar o espaço de trabalho com outro módulo.',
      addCta: 'Adicionar módulo', addConfirmTitle: 'Adicionar o módulo?',
      moduleLabel: 'Módulo', planLabel: 'Plano',
      // The booking table's column heads and its sum row's start date (#409 F12).
      booking: { price: 'Preço', seats: 'Lugares', monthly: 'Por mês', from: 'a partir de {date}' },
      apprenticeSeats: 'Lugares de formando reservados',
      apprenticeSeatsHint: 'Pelo menos 1 lugar de formando para o módulo de formação.',
      apprenticeSeatsCeiling: 'Acima de {max} lugares de formando não existe plano de self-service – o plano é definido em conversa direta connosco:',
      apprenticeSeatAdjustment: 'Antes deste módulo ser removido estavam reservados {booked} lugares de formando, pelo que foi novamente adicionado com {booked} lugares em vez dos {requested} pedidos. É possível reduzi-los a partir da próxima cobrança.',
      added: '{module} adicionado.',
      addedPaymentRetrying: '{module} foi adicionado e está pronto a usar. Não foi possível cobrar o pagamento neste momento — será repetido automaticamente.',
      alreadyActive: '{module} já faz parte do plano.',
    },
    seats: {
      title: 'Lugares reservados',
      userSeats: 'Lugares de utilizador', apprenticeSeats: 'Lugares de formando',
      stepUp: 'Mais lugares', stepDown: 'Menos lugares',
      bookMore: 'Reservar mais lugares',
      confirmTitle: 'Reservar mais lugares?', confirmCta: 'Reservar lugares',
      chargeNote: 'Reservar mais lugares implica a cobrança de um valor proporcional ao restante deste ciclo de faturação.',
      confirmTitleDecrease: 'Reduzir os lugares reservados?',
      reduceCta: 'Reduzir lugares',
      decreaseNote: 'Hoje não é cobrado nem creditado nada — a reserva muda a {date}.',
      decreaseNoteImmediate: 'Não é cobrado nem creditado nada — a reserva muda de imediato.',
      decreaseScheduled: 'Redução de lugares agendada para {date}.',
      mixedDirection: 'Reservar mais lugares e reduzir lugares são passos separados: os lugares acrescentados são cobrados hoje e os reduzidos entram em vigor na próxima faturação.',
      belowUsage: 'Este espaço de trabalho usa mais lugares do que isso. Mantenha pelo menos {count}.',
      usageCheckUnavailable: 'Não foi possível verificar quantos lugares estão ocupados neste momento. Tente novamente dentro de instantes.',
      leaveFreelancer: 'Isto sai do modo freelancer.',
      returnFreelancer: 'Isto regressa ao modo freelancer — uma pessoa, um lugar.',
      booked: 'Os lugares reservados foram atualizados.',
      bookedPaymentRetrying: 'Os lugares estão reservados e prontos a usar. Não foi possível cobrar o pagamento neste momento — será repetido automaticamente.',
      bookFailed: 'Não foi possível reservar os lugares. Tente novamente.',
    },
    seatPanel: {
      inUse: '{used} de {booked} em uso',
      bookedOnly: '{booked} reservados',
      useUnknown: 'Não foi possível saber quantos estão em uso neste momento.',
      manage: 'Gerir lugares',
      pendingUsers: 'Os lugares de utilizador mudam para {target} a {date} — até lá estão reservados {current}.',
      pendingApprentices: 'Os lugares de formando mudam para {target} a {date} — até lá estão reservados {current}.',
      reflooredUsers: 'A redução para {requested} lugares de utilizador foi aplicada com {booked}: existem {used} pessoas neste espaço de trabalho e cada uma ocupa um lugar. Remova as pessoas que já não são necessárias e reduza novamente.',
      reflooredApprentices: 'A redução para {requested} lugares de formando foi aplicada com {booked}: existem {used} formações em curso. Termine as que já não são necessárias e reduza novamente.',
      // A demo workspace's apprentices hold no booked seat (issue 364 F4/F30):
      // the creation gate ignores the booking while the demo runs, so the count
      // excludes them and this row says so.
      demoNotCounted: 'Os aprendizes dos dados de demonstração não ocupam lugares reservados: não são contados aqui e desaparecem quando a demonstração é convertida.',
    },
    // The seat price calculator (issue 364 F30). Every FIGURE it shows arrives
    // from the API; these are only the words around them.
    calc: {
      title: 'Quanto custa esta reserva',
      includes: 'O que a reserva inclui e quanto custa por mês.',
      userSeatsCount: '{count} lugares de utilizador',
      apprenticeSeatsCount: '{count} lugares de aprendiz',
      aiQuotaUpgradesCount: '{count} × extensão',
      subtotal: 'Subtotal',
      volumeDiscount: 'Desconto de volume',
      monthlyTotal: 'Total mensal',
      currentTotal: 'Atualmente o valor é de {amount} por mês.',
      newMonthlyTotal: 'A partir da próxima fatura: {amount} por mês.',
      netNote: 'Preços sem IVA. Reservar mais lugares implica ainda um valor único proporcional ao resto do ciclo de faturação atual.',
    },
    // The AI quota card (#665). Every figure it shows arrives from the API.
    aiQuota: {
      title: 'Quota de IA',
      usageLink: 'Onde é usada',
      ownKey: 'Este espaço de trabalho usa o lumi com uma chave própria de um fornecedor de IA, por isso não tem quota de IA — o fornecedor fatura cada token diretamente.',
      suspended: 'A quota de IA está em pausa enquanto o espaço de trabalho estiver suspenso.',
      unlimited: 'Não se aplica nenhuma quota de IA a este espaço de trabalho — o lumi retirou o limite.',
      intro: 'O lumi, as funções de IA de todos os módulos e os agentes de IA externos que os membros ligam partilham uma única quota: até {limit} tokens por ciclo de faturação. É reposta no início de cada ciclo de faturação; os tokens não usados não transitam.',
      included: 'Incluída',
      includedDerived: 'com os lugares reservados',
      includedOverride: 'definida pelo lumi para este espaço de trabalho',
      tokensValue: '{tokens} tokens por ciclo',
      upgrades: 'Extensões da quota',
      upgradesNone: 'Nenhuma reservada',
      upgradesValue: 'Reservadas: {count} · +{tokens} tokens',
      used: 'Usado neste ciclo',
      usedValue: '{used} de {limit} tokens',
      usedNoLimit: '{used} tokens até agora',
      resetsOn: 'Reposta a {date}',
      stepPrice: 'Uma extensão acrescenta {tokens} tokens por ciclo de faturação por {amount} por mês.',
      stepUp: 'Mais uma extensão',
      stepDown: 'Menos uma extensão',
      removeCta: 'Remover na próxima data de faturação',
      confirmTitle: 'Adicionar uma extensão da quota de IA?',
      confirmTitleDecrease: 'Remover uma extensão da quota de IA?',
      confirmCta: 'Reservar extensão',
      trialWarning: 'Isto custa dinheiro real, também durante o período de teste: o cartão é debitado hoje, proporcionalmente ao resto do período de teste, no máximo por um mês, e depois todos os meses.',
      cardRequired: 'Uma extensão da quota de IA requer um cartão ativo, também durante o período de teste. Primeiro é preciso adicionar um cartão — assim que estiver confirmado, a extensão pode ser reservada.',
      promoExcluded: 'O código não se aplica à quota de IA: uma extensão nunca é objeto de desconto e é cobrada ao preço de tabela.',
      chargeNote: 'Uma extensão implica a cobrança de um valor proporcional ao restante deste ciclo de faturação e aplica-se de imediato.',
      decreaseNote: 'Hoje não é cobrado nem creditado nada. A extensão mantém-se até {date}; a partir daí aplica-se a quota menor.',
      decreaseNoteGeneric: 'Hoje não é cobrado nem creditado nada — a extensão termina na próxima data de faturação.',
      newQuota: 'Depois: até {limit} tokens por ciclo de faturação.',
      changeDelta: '{tokens} tokens · {amount} / mês',
      addCtaPrice: 'Adicionar extensão da quota · {amount} / mês',
      booked: 'As extensões da quota de IA foram atualizadas.',
      bookedPaymentRetrying: 'A extensão da quota de IA está reservada e aplica-se de imediato. Não foi possível cobrar o pagamento neste momento — será repetido automaticamente.',
      decreaseScheduled: 'A extensão da quota de IA termina a {date}.',
      pending: 'As extensões da quota mudam para {target} a {date} — até lá estão reservadas {current}.',
      bookFailed: 'Não foi possível alterar as extensões da quota de IA. Tente novamente.',
    },
    scheduled: {
      resizeTo: 'Mudar para {plan}', remove: 'Remover módulo',
      effective: 'em vigor a {date}', revert: 'Anular', reverted: 'Alteração agendada anulada.',
    },
    proration: {
      title: 'Confirmar alteração de plano', stepFrom: 'Atual', stepTo: 'Novo',
      chargeNote: 'Fazer o upgrade agora implica a cobrança de um valor proporcional ao restante deste ciclo de faturação.',
      freeNote: 'Esta alteração aplica-se de imediato e sem custos adicionais durante o período de teste.',
      confirm: 'Confirmar e fazer upgrade', cancel: 'Cancelar',
      charged: 'Cobrado {amount}.', appliedImmediate: 'O novo plano está ativo.',
      appliedScheduled: 'Agendado — em vigor a {date}.',
      calculating: 'A apurar o valor exato…',
      chargeExact: 'Serão cobrados {amount} hoje.',
      noChargeToday: 'Hoje não é cobrado nada.',
    },
    profile: {
      title: 'Dados de faturação', subtitle: 'Preencher os dados de faturação para ativar o pagamento.',
      legalName: 'Nome legal da empresa', addressLine1: 'Morada', addressLine2: 'Morada (linha 2)',
      postalCode: 'Código postal', city: 'Localidade', vatId: 'NIF',
      vatOptional: 'Opcional — obrigatório para a autoliquidação dentro da UE.',
      save: 'Guardar dados', edit: 'Editar dados de faturação', error: 'Não foi possível guardar os dados de faturação.',
      saved: 'Dados de faturação guardados.',
      vatPending: 'Não foi possível validar o NIF neste momento. Tentar novamente dentro de instantes.',
      vatInvalid: 'Não foi possível validar este NIF. Verificar os dados.',
      vatRequired: 'É obrigatório um NIF válido para o país antes de adicionar um cartão.',
      completeFirst: 'Preencher os dados de faturação antes de adicionar um cartão.',
    },
    cancel: {
      title: 'Cancelar subscrição',
      body: 'Cancelar a subscrição. O espaço de trabalho permanece ativo até ao final do ciclo de faturação atual.',
      reason: 'Motivo (opcional)', confirm: 'Cancelar subscrição', confirmTitle: 'Cancelar subscrição?',
      confirmBody: 'A subscrição termina a {date}. Até lá, tudo continua a funcionar.',
      note: 'Até lá, tudo continua a funcionar, incluindo a exportação de todo o espaço de trabalho. Depois, o espaço de trabalho é fechado; os dados ficam guardados durante algum tempo e os proprietários são avisados antes de qualquer eliminação. Se tiver de desaparecer mais cedo, use «{deletion}».',
      pending: 'Cancelamento agendado — a subscrição termina a {date}.', pendingNoDate: 'Cancelamento agendado.',
      revert: 'Manter subscrição', error: 'Não foi possível cancelar a subscrição.',
      done: 'Cancelamento agendado. O espaço de trabalho permanece ativo até ao fim do ciclo de faturação atual.', revertDone: 'Cancelamento revertido. A subscrição continua normalmente.',
    },
    deletion: {
      title: 'Eliminar espaço de trabalho (RGPD)',
      body: 'Solicitar a eliminação permanente deste espaço de trabalho e de todos os seus dados. Após um breve período de tolerância, esta ação é irreversível.',
      request: 'Solicitar eliminação', reason: 'Motivo (opcional)',
      confirmTitle: 'Solicitar a eliminação do espaço de trabalho?',
      confirmBody: 'Todos os dados serão apagados permanentemente após um breve período de tolerância. Esta ação é irreversível.',
      pending: 'Eliminação solicitada — os dados são apagados após {date}.', pendingNoDate: 'Eliminação solicitada e a aguardar revisão.',
      cancel: 'Cancelar pedido de eliminação', error: 'Não foi possível submeter o pedido de eliminação.',
      requested: 'Eliminação solicitada. Vamos apagar o espaço de trabalho após o período de tolerância.', canceled: 'Pedido de eliminação retirado. O espaço de trabalho é mantido.',
      confirmType: 'Escrever o nome do espaço de trabalho ({name}) para confirmar',
      cancelConfirmTitle: 'Retirar o pedido de eliminação?',
      cancelConfirmBody: 'O espaço de trabalho e todos os seus dados são mantidos. É possível voltar a solicitar a eliminação a qualquer momento.',
    },
    moduleNames: { core: 'lumi-HR Core', ats: 'Recrutamento', time_tracking: 'Tempo', apprenticeship: 'Ausbildung' },
    planNames: {
      ats: { seat: 'Por utilizador', enterprise: 'Enterprise', unknown: '—' },
      time: { seat: 'Por utilizador', enterprise: 'Enterprise', unknown: '—' },
      apprenticeship: { seat: 'Por formando', enterprise: 'Enterprise', unknown: '—' },
      // People Pro is retired (#596), but issued invoices keep their `peoplePro.seat`
      // line (GoBD) and render through this entry — keep it while any exists.
      peoplePro: { seat: 'Por utilizador', enterprise: 'Enterprise', unknown: '—' },
      // The AI quota upgrade line (#665): its displayKey is `ai_quota.upgrade`.
      ai_quota: { upgrade: 'Extensão da quota de IA (+1.000.000 tokens por ciclo de faturação)' },
    },
    onboard: {
      // Three honest branches, never a CTA without a control (#364 F18/F23).
      // `exempt` is checked FIRST, ahead of demo: an operator-granted exemption
      // is a deliberate state, not a broken signup and not a demo limitation.
      exempt: { title: 'Este espaço de trabalho está isento de faturação', body: 'A lumi definiu que este espaço de trabalho não é faturado, pelo que não tem conta de faturação e nada é nem será cobrado. Só a lumi pode alterar isto — não há nada a configurar aqui.' },
      demo: { title: 'A faturação não está disponível no modo de demonstração', body: 'Este espaço de trabalho funciona com dados de demonstração, por isso ainda não há nada para faturar. A faturação poderá ser configurada assim que converter a demonstração numa configuração real — o banner de demonstração no topo da página inicia esse processo.' },
      // The stranded signup's real recovery is the buyer redoing the SAME checkout,
      // which resumes THIS workspace (issue 364 F25) — support is the fallback, and
      // for anyone who is not the buyer it is the only route they have.
      stranded: { title: 'A configuração da faturação não foi concluída', buyerBody: 'O seu registo não foi concluído, por isso este espaço de trabalho ainda não tem conta de faturação e nada está a ser cobrado. Pode concluí-lo: volte ao pagamento e adquira novamente os mesmos módulos — assim este espaço de trabalho é retomado em vez de ser criado um segundo. Se mesmo assim não avançar, fale connosco e concluímos isto consigo.', otherBody: 'O seu registo não foi concluído, por isso este espaço de trabalho ainda não tem conta de faturação e nada está a ser cobrado. Só a pessoa que registou este espaço de trabalho o pode concluir, voltando ao pagamento e adquirindo novamente os mesmos módulos. Peça-lhe que o faça, ou fale connosco e concluímos isto consigo.', checkoutCta: 'Voltar ao pagamento', cta: 'Contactar o suporte' },
    },
    // The four documents this workspace's billing relationship is
    // governed by, on the landing host (#576 M2) — not a "version you
    // accepted" claim, just the current published text.
    contractDocuments: {
      title: 'Documentos contratuais',
      terms: 'Termos',
      avv: 'Acordo de Tratamento de Dados (AVV)',
      tom: 'Medidas Técnicas e Organizativas (TOM)',
      subprocessors: 'Subcontratantes',
    },
  },
  login: {
    ssoApple: 'Iniciar sessão com a Apple',
    passkeySignIn: 'Iniciar sessão com uma chave de acesso',
    passkeySigningIn: 'A iniciar sessão…',
    passkeyFailed: 'O início de sessão com chave de acesso falhou. Tente novamente ou use a palavra-passe.',
    title: 'lumi-HR Suite',
    subtitle: 'Iniciar sessão para continuar',
    email: 'E-mail',
    emailPlaceholder: "nome{'@'}empresa.pt",
    password: 'Palavra-passe',
    passwordPlaceholder: 'Palavra-passe',
    signIn: 'Entrar',
    signingIn: 'A entrar…',
    failed: 'Falha no login',
    forgotPassword: 'Palavra-passe esquecida?',
    lostPhone: 'Perdeu o telemóvel?',
    orContinueWith: 'ou continuar com',
    ssoGoogle: 'Iniciar sessão com o Google',
    ssoMicrosoft: 'Iniciar sessão com a Microsoft',
    ssoEnterprise: 'Iniciar sessão com o SSO da empresa',
    ssoOnly: 'O início de sessão nesta área de trabalho é feito através do SSO da empresa.',
    adminLogin: 'Início de sessão de administrador',
    ssoError: 'Falha no início de sessão SSO. Tentar novamente.',
    ssoSeatLimit: 'Este workspace não tem nenhum lugar de utilizador livre, por isso não foi possível criar uma conta. Peça ao proprietário do workspace ou a um Billing Manager para reservar mais um lugar — tentar novamente não ajudará até lá.',
    ssoLinkRequired: 'Não foi possível associar automaticamente este início de sessão empresarial à sua conta lumi. Inicie sessão de outra forma e associe depois o início de sessão empresarial em Conta e segurança.',
    ssoEmployeeNoticeIncomplete: 'Este workspace ainda não está pronto: os avisos para colaboradores ainda têm campos por preencher. Peça ao proprietário do workspace, a uma administração de suite ou ao encarregado de proteção de dados para os preencher na secção Avisos legais — tentar novamente não ajudará até lá.',
    ssoLegalReadinessUnavailable: 'Não foi possível verificar agora se este workspace está pronto. Tente novamente dentro de alguns minutos.',
    ssoOperatorPasswordOnly: 'As contas de administração de sistema iniciam sessão com a palavra-passe e a aplicação de autenticação, não com este fornecedor.',
    mfaTitle: 'Introduza o seu código de autenticação',
    mfaIntro: 'Esta é uma conta de administração de sistema. Introduza o código de 6 dígitos da sua aplicação de autenticação ou um dos seus códigos de recuperação.',
    mfaCode: 'Código',
    mfaSubmit: 'Entrar',
    mfaBack: 'Voltar',
    mfaInvalid: 'Este código não está correto.',
    mfaReused: 'Este código já foi utilizado. Aguarde o próximo na sua aplicação.',
    mfaExpired: 'Este início de sessão expirou. Inicie sessão novamente com a sua palavra-passe.',
    mfaEnrolOnConsole: 'Esta conta de administração de sistema ainda não tem uma aplicação de autenticação. Configure-a primeiro iniciando sessão na consola lumi.',
    tenantLogoAlt: 'Logótipo da área de trabalho',
    poweredBy: 'Com tecnologia',
  },
  loginBranding: {
    nav: 'Página de início de sessão',
    title: 'Página de início de sessão',
    intro: 'A página de início de sessão desta área de trabalho pode ter logótipo, cor e imagem de fundo próprios. É vista por todas as pessoas que iniciam sessão aqui.',
    retry: 'Tentar novamente',
    loadFailed: 'Não foi possível carregar as definições atuais.',
    form: {
      title: 'Aspeto',
      logo: 'Logótipo',
      logoHint: 'PNG, JPEG, WebP ou GIF, até 2 MB. Deixe vazio para manter o logótipo lumi.',
      image: 'Imagem de fundo',
      imageHint: 'Apresentada por trás do cartão de início de sessão. PNG, JPEG, WebP ou GIF, até 8 MB.',
      upload: 'Carregar',
      replace: 'Substituir',
      remove: 'Remover',
      empty: 'Sem imagem',
      uploaded: 'Imagem carregada.',
      removed: 'Imagem removida.',
      tooLarge: 'Esse ficheiro é demasiado grande.',
      wrongType: 'Só são aceites imagens PNG, JPEG, WebP e GIF.',
      uploadFailed: 'Não foi possível carregar a imagem. Tente novamente.',
      removeFailed: 'Não foi possível remover a imagem. Tente novamente.',
      removeConfirm: 'A imagem é retirada da página de início de sessão e eliminada. Não é possível anular.',
      primaryColor: 'Cor principal',
      colorPlaceholder: 'p. ex. 1a2b3c',
      colorInvalid: 'Indicar uma cor hexadecimal, como 1a2b3c.',
      clear: 'Limpar',
      save: 'Guardar',
      saved: 'Página de início de sessão atualizada.',
      discard: 'Descartar',
      liveNote: 'As alterações guardadas ficam visíveis na próxima abertura da página de início de sessão.',
    },
    preview: {
      title: 'Pré-visualização',
      hint: 'Assim fica a página de início de sessão com os valores acima.',
      logoAlt: 'Pré-visualização do logótipo',
    },
  },
  authFlow: {
    forgot: {
      title: 'Repor a palavra-passe',
      subtitle: 'Será enviado um link para a repor.',
      email: 'E-mail',
      submit: 'Enviar link',
      done: 'Se existir uma conta com esse e-mail, foi enviado um link de reposição.',
      backToLogin: 'Voltar ao início de sessão',
    },
    reset: {
      title: 'Definir uma nova palavra-passe',
      password: 'Nova palavra-passe',
      confirm: 'Confirmar palavra-passe',
      submit: 'Guardar palavra-passe',
      success: 'A palavra-passe foi alterada. Já é possível iniciar sessão.',
      goToLogin: 'Ir para o início de sessão',
      invalid: 'Este link é inválido ou expirou.',
      mismatch: 'As palavras-passe não coincidem.',
      tooShort: 'A palavra-passe deve ter pelo menos 8 caracteres.',
      missingToken: 'Nenhum token válido encontrado.',
    },
    invite: {
      title: 'Configurar a conta',
      subtitle: 'Escolher uma palavra-passe para ativar a conta.',
      forTenant: 'Convite para {tenant}',
      password: 'Palavra-passe',
      confirm: 'Confirmar palavra-passe',
      submit: 'Ativar conta',
      submitting: 'A ativar…',
      invalid: 'Este convite é inválido ou expirou.',
      mismatch: 'As palavras-passe não coincidem.',
      tooShort: 'A palavra-passe deve ter pelo menos 8 caracteres.',
      passkey: {
        title: 'Configurar o início de sessão',
        intro: 'O início de sessão no lumi é feito com uma chave de acesso: impressão digital, rosto ou PIN do dispositivo. Sem palavra-passe para memorizar.',
        sentTo: 'Enviado para {phone}',
        create: 'Criar uma chave de acesso',
        creating: 'A aguardar o dispositivo…',
        instead: 'Usar antes uma chave de acesso',
        or: 'ou',
        unsupported: 'Este navegador não consegue criar uma chave de acesso. Abra o link no telemóvel ou num navegador atualizado.',
        unavailable: 'As chaves de acesso não estão disponíveis aqui para este espaço de trabalho. Contacte o administrador.',
        expired: 'Demorou demasiado tempo. Tente novamente.',
        alreadyRegistered: 'Este dispositivo já tem uma chave de acesso para o lumi.',
        failed: 'Não foi possível criar a chave de acesso. Tente novamente.',
      },
    },
    recover: {
      title: 'Perdeu o telemóvel?',
      subtitle: 'Introduza o número de telemóvel e será enviado por SMS um link para configurar uma nova chave de acesso.',
      phone: 'Número de telemóvel',
      phoneHint: 'Com o indicativo do país, p. ex. +351 912 345 678',
      submit: 'Enviar link',
      done: 'Se este número pertencer a uma conta aqui, foi-lhe enviado um link. É válido durante 15 minutos.',
      enrolTitle: 'Configurar uma nova chave de acesso',
      enrolSubtitle: 'Crie uma chave de acesso neste dispositivo. Todas as outras sessões da conta serão terminadas.',
      create: 'Criar uma nova chave de acesso',
      invalid: 'Este link é inválido ou expirou. Peça um novo.',
    },
    verify: {
      verifying: 'A confirmar o e-mail…',
      success: 'O endereço de e-mail foi confirmado.',
      invalid: 'Este link de confirmação é inválido ou expirou.',
      backToLogin: 'Ir para o início de sessão',
    },
  },
  account: {
    // AI agent connections on the account page (ADR 0103 rule 13).
    agentConnections: {
      title: 'Ligações de agentes de IA',
      hint: 'Clientes de IA que permitiu agir em seu nome num espaço de trabalho. Cada um trabalha exatamente com as suas permissões, e o que lê vai para o fornecedor desse cliente.',
      none: 'Nenhum agente de IA ligado.',
      inWorkspace: 'no espaço de trabalho {workspace}',
      scope: {
        read: 'ler',
        act: 'agir com confirmação',
        ask: 'perguntar ao lumi',
      },
      lastUsed: 'Utilizado pela última vez em {when}',
      connectedOn: 'Ligado em {when}, ainda não utilizado',
      standing: {
        label: 'Executar ações nos meus próprios registos sem perguntar',
        hint: 'Nunca abrange registos de outras pessoas nem decisões desfavoráveis.',
        notOffered: 'Esta ligação não admite um consentimento permanente.',
        failed: 'Não foi possível alterar a definição. Tente novamente.',
      },
      rolePins: {
        notHeld: 'Já não tem essa função neste módulo.',
        failed: 'Não foi possível alterar a função. Tente novamente.',
      },
      disconnect: 'Desligar',
      disconnectConfirm: '“{client}” perde de imediato o acesso a {workspace}. Para o voltar a utilizar, ligue-o de novo a partir do cliente.',
      disconnected: '{client} desligado.',
      disconnectFailed: 'Não foi possível terminar a ligação. Tente novamente.',
    },
    passkeys: {
      removeConfirm: 'Esta passkey será removida. O dispositivo que a utiliza deixa de poder iniciar sessão com ela.',
      title: 'Chaves de acesso',
      hint: 'Uma chave de acesso inicia a sua sessão com o seu dispositivo — impressão digital, rosto ou PIN. Nada para memorizar e nada para roubar por phishing.',
      none: 'Ainda não há chaves de acesso.',
      add: 'Adicionar uma chave de acesso',
      remove: 'Remover',
      unnamed: 'Chave de acesso',
      lastUsed: 'Última utilização a {when}',
      neverUsed: 'Nunca utilizada',
      added: 'Chave de acesso adicionada.',
      removed: 'Chave de acesso removida.',
      addFailed: 'Não foi possível adicionar a chave de acesso. Tente novamente.',
      removeFailed: 'Não foi possível remover a chave de acesso. Tente novamente.',
      alreadyRegistered: 'Este dispositivo já tem uma chave de acesso para o lumi.',
      lastMethod: 'Não pode remover o seu único método de início de sessão. Defina primeiro uma palavra-passe ou adicione outra chave de acesso.',
      lostDevice: 'Perdeu um telemóvel ou outro dispositivo? Remova a respetiva chave de acesso desta lista — é isso que lhe retira o acesso à conta.',
    },
    currentPassword: 'Palavra-passe atual',
    phone: {
      title: 'Número de início de sessão',
      hint: 'A sua conta inicia sessão com uma chave de acesso. Este número recebe os links de convite e de recuperação.',
    },
    email: {
      title: 'Endereço de início de sessão',
      hint: 'O endereço com que inicia sessão. Alterá-lo altera também o endereço que os seus espaços de trabalho mostram de si.',
      newLabel: 'Novo endereço',
      submit: 'Pedir alteração',
      pending: 'A aguardar confirmação em {email}. Siga a ligação que enviámos para lá.',
      cancel: 'Cancelar esta alteração',
      cancelled: 'A alteração de endereço pendente foi cancelada.',
      sent: 'Consulte a nova caixa de correio. Nada muda até seguir a ligação.',
      refused: 'Esse endereço não pode ser usado nesta conta. Um dos seus espaços de trabalho só permite endereços nos seus próprios domínios.',
      failed: 'Não foi possível pedir a alteração. Tente novamente.',
      ssoManaged: 'O seu endereço de início de sessão é gerido pelo seu fornecedor de identidade.',
    },
    password: {
      title: 'Palavra-passe',
      hint: 'Alterar a palavra-passe termina a sessão em todos os outros dispositivos.',
      newLabel: 'Nova palavra-passe',
      confirmLabel: 'Repita a nova palavra-passe',
      submit: 'Alterar palavra-passe',
      changed: 'A sua palavra-passe foi alterada. Os outros dispositivos foram desligados.',
      wrongCurrent: 'A palavra-passe atual não está correta.',
      failed: 'Não foi possível alterar a palavra-passe. Tente novamente.',
      tooShort: 'A nova palavra-passe tem de ter pelo menos 8 caracteres.',
      mismatch: 'As duas novas palavras-passe não coincidem.',
      ssoOnly: 'Esta conta inicia sessão através do seu fornecedor de identidade, por isso não tem palavra-passe. Pode adicionar uma como alternativa — enviamos-lhe uma ligação.',
      sendLink: 'Enviar-me uma ligação para definir uma palavra-passe',
      linkSent: 'Se for possível definir uma palavra-passe para esta conta, a ligação está a caminho.',
      linkFailed: 'Não foi possível enviar o pedido. Tente novamente.',
    },
    confirmEmail: {
      title: 'Confirme o seu novo endereço',
      working: 'A confirmar…',
      success: 'O seu endereço de início de sessão foi alterado. Volte a iniciar sessão com o novo endereço.',
      goToLogin: 'Ir para o início de sessão',
      backToAccount: 'Voltar a Conta e segurança',
      missingToken: 'Esta ligação está incompleta. Abra-a diretamente a partir da mensagem.',
      invalid: 'Esta ligação de confirmação é inválida ou expirou.',
      unavailable: 'Esta alteração já não pode ser aplicada. Peça-a novamente.',
    },
    // The undo half (#420): the notice mailed to the address being LEFT
    // BEHIND carries this link, and it only ever restores the status quo.
    cancelEmailChange: {
      title: 'Cancelar a alteração de endereço',
      working: 'A cancelar…',
      success: 'A alteração foi cancelada. Continua a iniciar sessão com o seu endereço atual.',
      goToLogin: 'Ir para o início de sessão',
      missingToken: 'Este link está incompleto. Abra-o diretamente a partir do e-mail.',
      invalid: 'Este link é inválido ou expirou — já não existe nenhuma alteração para cancelar.',
    },
    title: 'Conta e segurança',
    identities: 'Métodos de início de sessão associados',
    noIdentities: 'Nenhum método de início de sessão externo associado.',
    unlink: 'Remover',
    // #882: removing a linked sign-in method asks first, as removing a passkey does.
    unlinkConfirm: 'Este método de início de sessão será removido. Deixa de poder iniciar sessão na sua conta com ele.',
    linkGoogle: 'Associar o Google',
    linkMicrosoft: 'Associar a Microsoft',
    linkApple: 'Associar a Apple',
    lastMethod: 'Não é possível remover o único método de início de sessão. Definir primeiro uma palavra-passe.',
    linked: 'Método de início de sessão associado.',
    unlinked: 'Método de início de sessão removido.',
    linkFailed: 'Falha na associação.',
  },
  workspace: {
    title: 'Área de trabalho',
    subtitle: 'Selecionar um tenant e um módulo',
    brandName: 'lumi-HR Workspace',
    themeDark: 'Mudar para o modo escuro',
    themeLight: 'Mudar para o modo claro',
    welcomeTitle: 'Bem-vindo à área de trabalho',
    welcomeSubtitle:
      'Selecionar um tenant e um módulo de aplicação para começar.',
    availableModules: 'Módulos disponíveis',
    comingSoonSection: 'Em breve no lumi-HR',
    adminMode: 'Modo de administrador',
    aiUsage: {
      title: 'Utilização de IA',
      pageIntro: 'Se o lumi está disponível neste espaço de trabalho e o que a IA consumiu este mês.',
      loading: 'A carregar utilização…',
      remaining: '{n} restantes',
      periodLabel: 'Ciclo de faturação',
      historyTitle: 'Ciclos de faturação',
      usedThisPeriod: 'Usado neste ciclo de faturação',
      split: '{included} incluídos · +{upgrades} das extensões da quota',
      resetsOn: 'Reposta a {date}',
      periodFrom: 'Ciclo de faturação desde {date}',
      nearLimit: 'A quota de IA deste ciclo de faturação está quase esgotada. Uma extensão da quota em Faturação aumenta-a de imediato.',
      unlimited: 'Não se aplica nenhuma quota de IA a este espaço de trabalho.',
      ownKey: 'Este espaço de trabalho usa o lumi com uma chave própria de um fornecedor de IA, por isso não tem quota de IA.',
      noUsageYet: 'Ainda sem utilização de IA neste ciclo de faturação.',
      upgradeLink: 'Adicionar uma extensão da quota em Faturação',
      modules: {
        ats: 'Recrutamento',
        time: 'Tempo',
        time_tracking: 'Tempo',
        apprentice: 'Ausbildung',
        apprenticeship: 'Ausbildung',
        assistant: 'Assistente lumi',
        mcp: 'Agentes externos',
      },
    },
    active: 'Ativo',
    systemAdmin: 'Administrador de sistema',
    user: 'Utilizador',
    admin: 'Administração',
    comingSoon: 'Em breve',
    noTenants: 'Nenhum tenant disponível',
    createViaCheckout: 'Criar um espaço de trabalho na página de pagamento',
    loadFailed: 'Não foi possível carregar os tenants',
    planKlein: 'Pequeno',
    planMedium: 'Médio',
    planEnterprise: 'Enterprise',
    retry: 'Tentar novamente',
    logout: 'Sair',
    noAccess: 'Sem acesso',
  },
  support: {
    title: 'Pedidos de suporte',
    myTickets: 'Os meus pedidos',
    myTicketsTitle: 'Os meus pedidos de suporte',
    inbox: 'Caixa de entrada',
    inboxTitle: 'Caixa de entrada do suporte',
    inboxSubtitle: 'Tickets dos tenants que apoia',
    ticket: 'Ticket',
    newTicket: 'Novo pedido de suporte',
    newTicketTitle: 'Novo pedido de suporte',
    newTicketIntro: 'Descrever o problema para entrarmos em contacto.',
    sent: 'O seu pedido foi enviado.',
    goToMyRequests: 'Ir para os meus pedidos de suporte',
    subject: 'Assunto',
    subjectPlaceholder: 'Breve resumo',
    message: 'Mensagem',
    messagePlaceholder: 'Descrever o que aconteceu…',
    consentLabel: 'Reconheço que os meus dados são processados para tratar este pedido',
    send: 'Enviar',
    reply: 'Responder',
    markComplete: 'Marcar como resolvido',
    reopen: 'Reabrir',
    replyPlaceholder: 'Escrever uma resposta…',
    escalate: 'Escalar',
    escalated: 'Escalado',
    deescalate: 'Desescalar',
    deescalateBlocked: 'Este ticket ainda tem um acesso de suporte em aberto. Revogue-o primeiro e depois desescale.',
    close: 'Fechar',
    statusLabel: 'Estado',
    module: 'Módulo',
    tenant: 'Tenant',
    requester: 'Solicitante',
    updated: 'Atualizado',
    backToTickets: 'Voltar aos meus pedidos',
    status: {
      open: 'Aberto',
      in_progress: 'Em curso',
      answer: 'Respondido',
      closed: 'Fechado',
    },
    author: {
      user: 'Eu',
      support: 'Suporte',
      systemAdmin: 'Administrador do sistema',
    },
    empty: {
      myTitle: 'Ainda sem tickets',
      myBody: 'Os tickets de suporte criados aparecerão aqui.',
      inboxTitle: 'Nada para apoiar',
      inboxBody: 'Sem tickets de suporte nos tenants apoiados neste momento.',
      notFoundTitle: 'Ticket indisponível',
      notFoundBody: 'Não foi possível carregar este ticket. Pode ter sido removido ou não estar acessível.',
    },
  },
  notifications: {
    nav: 'Notificações',
    title: 'Notificações',
    subtitle: 'Assuntos que requerem atenção.',
    settings: 'Definições',
    backToWorkspace: 'Voltar ao espaço de trabalho',
    area: 'Área',
    areaAll: 'Todas as áreas',
    status: 'Estado',
    statusAll: 'Todas',
    statusUnread: 'Não lidas',
    statusRead: 'Lidas',
    perPage: 'Por página',
    markRead: 'Marcar como lida',
    markUnread: 'Marcar como não lida',
    markAllRead: 'Marcar todas como lidas',
    loading: 'A carregar…',
    empty: 'Está tudo em dia.',
    pageInfo: '{from}–{to} de {total}',
    prev: 'Anterior',
    next: 'Seguinte',
    retentionHint: 'As notificações são mantidas durante 6 meses.',
    settingsTitle: 'Configurar notificações por área',
    settingsSubtitle: 'Definir como receber notificações em cada área.',
    // #445 M4 packet 2: the settings screen must say plainly what it cannot
    // switch off, and what a switched-off Area still lets through.
    mustReachIntro: 'Alguns avisos sobre segurança, dinheiro, contratos, o espaço de trabalho e prazos legais chegam sempre a quem diz respeito — também aparecem no sino.',
    // A phone-only account (issue 698): no address, so the mail half never goes out.
    noMailAddress: 'A sua conta não tem endereço de e-mail, por isso os avisos chegam-lhe na aplicação (e como notificação push onde a permitiu). «{mailMode}» funciona assim como «{inAppMode}»: nada é enviado por e-mail.',
    mustReachStillReaches: 'Mesmo desativado, {list} continuam a chegar quando dizem respeito ao destinatário.',
    mandatoryReason: {
      billing: 'Não é possível desativar: valores em dívida têm de chegar à pessoa responsável.',
      legal: 'Não é possível desativar: as alterações contratuais têm de chegar à pessoa a quem dizem respeito, como prometem os nossos termos.',
    },
    mustReachFamily: {
      identity: 'avisos de segurança',
      money: 'avisos de faturação',
      legal: 'avisos contratuais',
      workspace: 'avisos sobre o estado do espaço de trabalho',
      privacy: 'avisos de prazos de privacidade',
      participation: 'pedidos à representação dos trabalhadores',
    },
    backToList: 'Voltar às notificações',
    modeOff: 'De todo',
    modeInApp: 'Apenas na aplicação',
    modeMailInApp: 'E-mail e na aplicação',
    saved: 'Guardado.',
    saveError: 'Não foi possível guardar. A definição foi reposta.',
    openTarget: 'Abrir o item associado',
    opening: 'A abrir…',
    openFailed: 'Não foi possível abrir esta notificação.',
    areas: {
      system: 'Sistema',
      timecard: 'Tempo',
      ats: 'Recrutamento',
      apprentice: 'Ausbildung',
      people: 'Pessoal',
      support: 'Suporte',
      postings: 'Anúncios de emprego',
      // Subscription, invoices, payment problems. A MANDATORY Area — the
      // row renders without a mode selector (review finding 3).
      billing: 'Faturação',
      // #373 M5: the contract-rollout notices (AGB, AVV, subprocessors). A
      // MANDATORY Area — the row renders without a mode selector.
      legal: 'Documentos contratuais',
    },
  },
  homebase: {
    // The owner's own details, asked for on Suite Home until given (issue 812); skipping asks first.
    ownDetails: {
      save: 'Guardar os meus dados',
      later: 'Mais tarde',
      saved: 'Obrigado — os dados foram guardados.',
      skip: {
        title: 'Saltar os dados pessoais?',
        body: 'Enquanto os dados não forem preenchidos, o registo próprio em Pessoal continua por confirmar. Isto significa: não é possível acrescentar dados de colaborador, como contrato, férias ou salário, não é possível ser indicado como responsável de ninguém e o registo aparece como «por confirmar» em Pessoal. Pode ser feito a qualquer momento — este lembrete volta amanhã.',
        fill: 'Preencher agora',
        skip: 'Saltar por agora',
      },
    },
    // The quiet "set up Lumi" panel on Suite Home: one fixed table of entries,
    // each a title + one benefit line; the rows are looked up per entry key.
    setup: {
      title: 'Configurar o lumi',
      subtitle: 'Nada disto é obrigatório. Tudo compensa quando chegar a altura.',
      hide: 'Já não preciso disto',
      viewAll: 'Ver tudo o que o lumi consegue fazer',
      rareHeading: 'Necessário com menos frequência',
      page: {
        title: 'O que o lumi consegue fazer.',
        subtitle: 'Tudo o que se pode configurar. O mais importante primeiro, o resto quando for preciso.',
        tipsTitle: 'Dicas na página inicial',
        tipsShown: 'O painel fica no topo da página inicial até deixar de ser necessário.',
        tipsHidden: 'O painel está oculto. Aqui volta a mostrá-lo.',
        emptyTitle: 'Aqui não há nada para configurar.',
        emptyBody: 'O que se pode configurar fica a cargo dos responsáveis da equipa. Fale com eles se faltar alguma coisa.',
      },
      sections: {
        suite: 'Início',
        ats: 'Recrutamento',
        time: 'Tempo',
        people: 'Pessoal',
        apprentice: 'Ausbildung',
      },
      entries: {
        login_branding: { title: 'Personalizar a página de início de sessão', hint: 'Logótipo e cores, para a equipa ver que está no sítio certo.' },
        portal_design: { title: 'Personalizar o portal de carreiras', hint: 'É assim que os candidatos veem primeiro a empresa.' },
        email_templates: { title: 'Modelos de e-mail', hint: 'Confirmação de receção, convite, recusa: escrever uma vez, usar sempre.' },
        job_posting_settings: { title: 'Dados para os anúncios de emprego', hint: 'Logótipo e pessoa de contacto. Os portais de emprego externos precisam de ambos.' },
        work_time_models: { title: 'Modelos de horário de trabalho', hint: 'Quem trabalha quantas horas e em que dias.' },
        company_holidays: { title: 'Encerramentos da empresa', hint: 'Dias em que a empresa está fechada.' },
        data_import: { title: 'Importar pessoas', hint: 'Aproveitar as listas existentes em vez de escrever tudo.' },
        company_profile: { title: 'Perfil da empresa', hint: 'Morada e dados essenciais que o lumi usa em muitos locais.' },
        org_units: { title: 'Unidades organizacionais', hint: 'Departamentos e locais segundo os quais muita coisa se ordena.' },
        payroll_handover: { title: 'Entrega salarial (DATEV)', hint: 'A lumi entrega as horas, o teu consultor fiscal calcula o salário.' },
        training_occupations: { title: 'Profissões de formação', hint: 'Que profissões são formadas.' },
        workflows: { title: 'Workflows', hint: 'Passos e aprovações próprios no processo de candidatura.' },
        application_forms: { title: 'Formulários de candidatura', hint: 'Que perguntas os candidatos respondem.' },
        offer_templates: { title: 'Modelos de oferta', hint: 'Preparar ofertas de contrato com marcadores.' },
        custom_fields: { title: 'Campos personalizados', hint: 'Dados adicionais em vagas e candidaturas.' },
        booking_types: { title: 'Tipos de registo', hint: 'O que pode ser registado além do tempo de trabalho.' },
        leave_types: { title: 'Tipos de ausência', hint: 'Férias, doença e tipos de ausência próprios.' },
        api_settings: { title: 'Interface (API)', hint: 'Passar os tempos aos teus próprios programas pela API. A entrega salarial está em Pessoal.' },
        time_clock: { title: 'Relógio de ponto', hint: 'Abrir no navegador de um tablet no local de trabalho: cada pessoa entra com o seu próprio acesso lumi e regista a entrada ou a saída.' },
        sso: { title: 'Single Sign-on', hint: 'Início de sessão com a conta da empresa.' },
        onboarding_templates: { title: 'Modelos de integração', hint: 'Listas de verificação para os primeiros dias dos novos colegas.' },
        recruiting_options: { title: 'Listas de opções', hint: 'Tratamentos, tipos de contrato e locais de trabalho entre os quais a equipa escolhe.' },
      },
    },
    greeting: { morning: 'Bom dia', day: 'Olá', evening: 'Boa noite' },
    // A linha de data sob a saudação ("Segunda-feira, 21 de setembro · Semana 39",
    // workspace-start M2) substitui o subtítulo estático.
    dateLine: { week: 'Semana {n}' },
    open: 'Abrir',
    recents: 'Recentes',
    recentKinds: { report: 'Relatório semanal', job: 'Vaga', application: 'Candidatura' },
    moreActions: 'Mais ações',
    clockedInSince: 'Registado desde as {time}',
    clockedOut: 'Saída registada',
    clockOut: 'Registar saída',
    clockIn: 'Registar entrada',
    projectRunning: 'Tempo de projeto a decorrer',
    projectRunningSince: 'Desde as {time}',
    startProject: 'Iniciar um projeto',
    // The clock tile for a person freed from booking working time (issue 981): the sentence, then the way to a project.
    workTimeFree: 'Pelo contrato, regista-se apenas tempo de projeto, não tempo de trabalho.',
    // The Stempeluhr's project choice once clocked in (Zeit's "Woran arbeitest du?"): the tile's field and its sheet.
    clockProject: {
      title: 'Em que está a trabalhar?',
      none: 'Sem projeto',
      noneSub: 'Conta como «Não atribuído»',
      choose: 'Escolher projeto e atividade',
      fieldLabel: 'Em que está a trabalhar? Agora: {current}',
      runningWith: '{activity} · desde as {time}',
      runningSince: 'Desde as {time}',
      activityStep: 'Que atividade?',
      back: 'Todos os projetos',
      defaultActivity: 'Predefinida',
      search: 'Procurar projeto',
      noMatch: 'Nenhum projeto encontrado',
      close: 'Fechar',
    },
    provisioning: 'A configurar — pode demorar um minuto.',
    preferences: 'Preferências',
    seeMyOrg: 'A minha organização',
    // What each module Lumi still sells actually does (issue 261 M2). Longer than the
    // launcher's one-liners (app-kit's `lumiModules.<key>.description`): this is one
    // app, so the home can say it in the module's own vocabulary.
    teaser: {
      about: {
        ats: 'Anúncios de emprego, candidaturas e o funil de recrutamento — do primeiro CV ao contrato assinado.',
        time_tracking: 'Registo de entradas e saídas, contas de tempo de trabalho, ausências e horas extra, prontos para o registo de tempos.',
        apprenticeship: 'Cadernos de formação digitais, planos de formação e avaliações para cada formando.',
      },
      heading: 'Mais módulos',
    },
    empty: 'Ainda não há nada aqui — abra o módulo para começar.',
    unavailable: 'Não é possível carregar neste momento.',

    goToModule: 'Ir para {module}', expand: 'Expandir {module}', collapse: 'Recolher {module}',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    people: { selfService: 'Os meus dados' },
    myDocuments: {
      title: 'Os meus documentos',
      downloadFailed: 'Falha na transferência – tente novamente mais tarde.',
      showAll: 'Mostrar todos ({count})',
      showLess: 'Mostrar menos',
      handIn: 'Entregar um documento',
      empty: 'Ainda nada por aqui. Pode entregar um certificado, uma declaração, uma baixa médica ou uma cópia do documento de identificação para o seu processo.',
      kindLabel: 'De que se trata?',
      fileLabel: 'Ficheiro – escolher ou fotografar',
      send: 'Enviar',
      cancel: 'Cancelar',
      handedIn: 'Entregue em {date} · a aguardar os RH',
      accepted: 'Entregue em {date} · aceite',
      sentBack: 'Devolvido em {date}: «{reason}»',
      handInAgain: 'Entregar novamente',
      dismiss: 'Ocultar',
      error: {
        file_refused: 'Não foi possível aceitar este ficheiro – tente outro ficheiro.',
        file_too_large: 'Este ficheiro é demasiado grande – o limite é 25 MB.',
        file_empty: 'Este ficheiro está vazio – escolha outro ficheiro.',
        file_missing: 'Escolha primeiro um ficheiro.',
        quota_exceeded: 'O seu processo atingiu o limite de armazenamento – contacte os RH.',
        invalid_category: 'Escolha de que tipo de documento se trata.',
        not_possible: 'Neste momento não é possível entregar – contacte os RH.',
        generic: 'A entrega falhou – tente novamente mais tarde.',
        scan_unavailable: 'Não foi possível verificar o ficheiro neste momento. Tente novamente dentro de instantes.',
      },
      category: {
        contract: 'Contrato de trabalho',
        contract_amendment: 'Adenda ao contrato',
        certificate: 'Certificado de trabalho',
        attestation: 'Declaração',
        payslip: 'Recibo de vencimento',
        health_certificate: 'Baixa médica / atestado médico',
        identification: 'Documento de identificação',
        other: 'Outro',
      },
    },
    admin: {
      users: 'Utilizadores',
      usersMoved: {
        title: 'A gestão de utilizadores passou para o Pessoal',
        redirecting: 'A abrir o Pessoal…',
        noPeople: 'Quem tem acesso a este espaço de trabalho é gerido em cada pessoa no Pessoal. O Pessoal não está disponível para si aqui — contacte o proprietário do espaço de trabalho.',
      },
    },
    verwaltung: { heading: 'Administração' },
    nav: { home: 'Painel', billing: 'Faturação', logout: 'Terminar sessão', language: 'Idioma', administration: 'Administração', sso: 'Single Sign-On', audit: 'Registo de auditoria', supportAccess: 'Acesso de suporte', aiUsage: 'Utilização de IA', dataProcessing: 'Tratamento de dados', dataRequests: 'Pedidos dos titulares dos dados', legalNotices: 'Avisos legais', statutoryRules: 'Regras legais', trainingOccupations: 'Profissões de formação', externalAgents: 'Agentes de IA externos', setup: 'Configurar' },
    // The running week against its Sollstunden (#403). `hoursUnit` is a
    // separate key because the figures are formatted with Intl and the unit
    // trails them in every language this app ships.
    week: {
      title: 'Esta semana',
      hoursUnit: 'h',
      balance: 'Conta de horas, a {date}: {balance}',
      balanceHint: 'Horas trabalhadas menos horas devidas até esse dia.',
      noTarget: 'Sem horário semanal definido.',
      trustBased: 'Aplica-se tempo de trabalho baseado na confiança: regista-se o início e o fim do trabalho, e não há objetivo nem conta de horas.',
      projectsMore: 'e mais {n}',
      days: 'Dias da semana',
    },
    heute: {
      clock: 'Registo de ponto',
      attention: 'Precisa de atenção',
      news: 'Novo',
      leaveRemaining: 'Férias restantes',
      days: 'Dia | Dias',
      kind: { interview: 'Entrevista', leave: 'Ausências', holiday: 'Feriado', exam: 'Exame', station: 'Rotação' },
    },
    facts: {
      ats: { total_jobs: 'Vagas', total_applications: 'Candidaturas', open_tasks: 'Tarefas abertas', new_applicants: 'Novos candidatos', create_job: 'Criar vaga', add_application: 'Adicionar candidatura', create_task: 'Criar tarefa', pipeline: 'Pipeline', pipeline_closed: '{n} fechadas', stage_other: 'Outras' },
      time: { week_hours: 'Horas esta semana', today_hours: 'Horas hoje', timesheet: 'A minha folha de horas', request_leave: 'Pedir ausência', approvals: 'Aprovações', team: 'Equipa', pending_approvals: 'Aprovações pendentes', leave_remaining: 'Férias restantes' },
      apprentice: { waiting: 'Por rever', active: 'Formandos', overdue: 'Semanas em falta', this_week: 'Esta semana', badges: 'Competências', write: 'Preencher semana', skills: 'Mural de competências', review: 'Rever relatórios', onboard: 'Adicionar formando', reports: 'Cadernos de relatórios', report_approved: 'Aprovados', report_submitted: 'A rever', report_rejected: 'Devolvidos', report_missing: 'Em falta' },
    },
  },
  preferences: {
    appearance: 'Aparência',
    theme: 'Tema',
    themeHint: 'Interface clara ou escura.',
    language: 'Idioma',
    languageHint: 'O idioma usado em todo o espaço.',
    attributions: 'Atribuições de dados abertos',
    placesCredit: 'Dados de locais © {source}, licenciados sob {licence}.',
    bankCodesCredit: "Códigos bancários: fonte {bundesbank}; códigos bancários austríacos © {oenb}, licenciados sob {licence}; códigos suíços e do Listenstaine © {six}.",
    healthInsurersCredit: "Entidades de seguro de saúde: ficheiro de dados mestre da segurança social do {gkv}.",
  },
  onboarding: {
    actions: { add: 'Adicionar', back: 'Voltar', next: 'Seguinte', remove: 'Remover' },
    modules: {
      ats: 'Recrutamento',
      time_tracking: 'Tempo',
      apprenticeship: 'Ausbildung',
    },
    fork: {
      // The headline is two keys: the lead and `titleMark`, the final beat that sits
      // on the highlighter stroke. The mark is always the LAST beat of the sentence.
      eyebrow: 'Boas-vindas à lumi',
      title: 'Ainda bem que',
      titleMark: 'está aqui.',
      subtitle: 'Como pretende começar? Pode mudar a qualquer momento.',
      // From a live demo the same page is the way out of it.
      eyebrowDemo: 'Sair da demonstração',
      titleDemo: 'Já explorou o suficiente.',
      titleDemoMark: 'Agora a sério.',
      subtitleDemo: 'Com a configuração guiada, a empresa de demonstração mantém-se até concluir.',
      reassure: 'Tem dúvidas? Comece pela demonstração – a qualquer momento passa para a configuração real.',
      seedFailed: 'A preparação dos dados de demonstração não foi concluída. Tente novamente.',
      seedFailedNotEmpty:
        'A demonstração precisa de módulos vazios, mas um dos seus módulos já contém dados. Remova-os primeiro ou escolha «Configurar a sua suite».',
      // #364 F19: why the fork opened mid-Finish. The wizard hands an admin back
      // here when the AVV is still unsigned; landing with nothing said is what
      // made a refused Finish read as a silent drop.
      avvRequiredNotice:
        'A configuração só pode ser concluída depois de o acordo de tratamento de dados (AVV) ser aceite. Aceite-o aqui para voltar diretamente ao guia de configuração.',
      // #364 F21 / ADR 0032 Decision 2: the fork is now also reached FROM a live
      // demo, so it needs the wizard's way out. Leaving costs nothing.
      backToDemo: 'Voltar à demonstração',
      demo: {
        eyebrow: 'Experimentar',
        title: 'Explorar com dados de demonstração',
        body: 'Preenchemos os seus módulos com uma empresa fictícia e coerente. Explore tudo à vontade, sem estragar nada.',
        modulesHint: 'Os módulos contratados estão sempre incluídos.',
        cta: 'Explorar a demonstração',
      },
      guided: {
        eyebrow: 'Configurar',
        title: 'Orientar-me passo a passo',
        body: 'Passo a passo até à sua suite real. Pausar, saltar um passo ou passar primeiro pela demonstração – tudo é possível.',
        bodyDemo: 'Passo a passo até à sua suite real. Se fechar a janela, volta à demonstração.',
        pointSaved: 'O seu progresso fica guardado',
        pointOptional: 'Cada passo é opcional',
        cta: 'Orientar-me passo a passo',
      },
      empty: {
        eyebrow: 'Por conta própria',
        titleFresh: 'Começar em branco',
        titleDemo: 'Descartar a demonstração e começar em branco',
        bodyFresh: 'Uma folha em branco. Vai configurando tudo aos poucos, ao seu ritmo.',
        bodyDemo: 'A empresa de demonstração é eliminada e começa a partir de uma base vazia.',
        warnDemo: 'Acontece de imediato e não pode ser anulado.',
        cta: 'Começar em branco',
      },
    },
    exitGate: {
      title: 'Antes de sair da demonstração',
      intro: 'Isto é o que o seu espaço de trabalho tem reservado e em que ponto está o período de teste. Adicione um módulo agora ou mais tarde em Faturação — a configuração funciona de qualquer forma.',
      booked: { title: 'Reservado' },
      // The colleagues invited from the demo bar, named before the owner ends the demo
      // (issue 669); `fallback` stands in when the roster could not be read.
      guests: {
        title: 'Colegas convidados para a demonstração',
        lead: 'Estes colegas perdem o acesso quando a demonstração termina:',
        fallback: 'Os colegas convidados para a demonstração perdem o acesso quando esta termina.',
        people: 'A equipa real é convidada a partir de Pessoal quando o espaço de trabalho estiver configurado.',
      },
      // What only the gate can say about a module booked at it (#409 F12): whether
      // its setup-guide section is there yet. The booking rows themselves are the
      // billing section's.
      bookedHere: {
        settingUp: 'A preparar {module}…',
        booked: '{module} está reservado e tem a sua própria secção no guia de configuração.',
        bookedPending: '{module} está reservado. A sua secção aparecerá no guia de configuração assim que o módulo estiver pronto.',
      },
      noManage: 'Apenas o proprietário do espaço de trabalho, um responsável de faturação ou um administrador do espaço podem reservar módulos. Ainda assim, é possível continuar sem reservar.',
      enforcement: 'Há um pagamento pendente neste espaço de trabalho. As reservas ficam em pausa até ser regularizado — a configuração da suite não.',
      factsUnavailable: 'Não foi possível carregar a reserva neste momento. Ainda assim, é possível continuar; está tudo na página de Faturação.',
      trial: {
        title: 'O período de teste',
        range: 'O período de teste começou em {start} e termina em {end}.',
        endOnly: 'O período de teste termina em {end}.',
        rangeFree: 'Grátis de {start} a {end}.',
        endOnlyFree: 'Grátis até {end}.',
        charge: 'A partir de {end}, são cobrados {amount} por mês pelo que está reservado, no início de cada mês de faturação.',
        chargeNoTotal: 'A partir de {end}, a reserva é cobrada mensalmente, no início de cada mês de faturação.',
        firstCharge: 'A primeira cobrança é em {date}.',
        demoCounted: 'O tempo passado na demonstração contou para o período de teste.',
        over: 'O período de teste terminou e a reserva é faturada mensalmente.',
        monthly: 'São {amount} por mês.',
        nextCharge: 'A próxima cobrança é em {date}.',
      },
      continue: 'Continuar para a configuração',
    },
    avv: {
      modalTitle: 'Aceitar o acordo de tratamento de dados (AVV)',
      modalBody:
        'Configurar a suite com dados reais significa que a lumi trata dados pessoais em seu nome. Antes de continuar, leia e aceite o nosso acordo de tratamento de dados (AVV) atual.',
      modalLinkText: 'Ler o AVV completo',
      modalCheckboxLabel: 'Li e aceito o AVV atual.',
      modalCancel: 'Ainda não',
      modalAccept: 'Aceitar e continuar',
    },
    preparing: {
      first: {
        title: 'A sua demonstração está a ser preparada.',
        body: 'Estamos a criar uma empresa fictícia e coerente em todos os seus módulos. Demora apenas um momento.',
      },
      reset: {
        title: 'A sua demonstração está a ser reposta.',
        body: 'Estamos a esvaziar a empresa de demonstração e a reconstruí-la de raiz. O seu espaço de trabalho e os seus colegas não são afetados. Demora apenas um momento.',
      },
      stuck: {
        note: 'Está a demorar mais do que o esperado.',
        cta: 'Configurar manualmente',
      },
    },
    nonAdmin: {
      title: 'Quase',
      titleMark: 'lá.',
      body: 'Quem administra a conta ainda está a configurar a suite. Assim que terminar, entra aqui diretamente.',
    },
    wizard: {
      title: 'Configurar a sua suite',
      subtitle: 'Aqui tudo é opcional e o seu progresso é guardado. Configure o que quiser, conclua a configuração ou volte à demonstração fechando esta janela.',
      subtitleCommitting: 'A sua configuração está a ser aplicada. Se um passo falhar, pode ignorá-lo e configurá-lo mais tarde nas definições.',
      crossRef: 'Usado em {modules} — pode alterar mais tarde em {owner}.',
      crossRefOwnerDefault: 'Pessoal',
      recovery: 'Não foi possível aplicar «{step}». Verifique aí os dados introduzidos e conclua novamente.',
      details: {
        step: 'Os seus dados',
        title: 'Os seus dados',
        subtitle: 'O seu próprio registo no Pessoal. Verifique o seu nome — ao guardá-lo, confirma o seu registo.',
        loading: 'A carregar o seu registo…',
        confirmed: 'O seu registo está confirmado como {name}. Pode alterá-lo mais tarde no Pessoal.',
        unavailable: 'Não foi possível carregar o seu registo neste momento. Pode confirmá-lo mais tarde no Pessoal.',
        firstName: 'Nome próprio',
        lastName: 'Apelido',
        required: 'Introduza o seu nome próprio e apelido.',
        hq: {
          title: 'A sede da empresa',
          why: 'O Lumi não funciona sem um local: precisa da sede da empresa como primeiro local, por exemplo para as vossas vagas.',
          street: 'Rua',
          postalCode: 'Código postal',
          city: 'Localidade',
          country: 'País',
          countryNone: 'Nenhum país selecionado',
          required: 'Introduza a rua, o código postal, a localidade e o país da sede da empresa.',
        },
      },
      general: {
        title: 'Geral',
        company: {
          title: 'Perfil da empresa',
        },
        name: {
          label: 'Nome da empresa',
          hint: 'Pré-preenchido a partir da finalização — edite se necessário. Obrigatório.',
          required: 'O nome da empresa é obrigatório.',
        },
        profile: {
          industry: 'Setor',
          employeeCountRange: 'Dimensão da empresa',
          employeeCountPlaceholder: 'p. ex. 50–200',
          foundedYear: 'Fundada',
          foundedYearPlaceholder: 'p. ex. 2010',
          legalForm: 'Forma jurídica',
          websiteUrl: 'Site',
        },
        place: {
          hint: 'Escolha uma cidade da lista como nome do local — ou escreva um nome próprio e confirme com Enter ou +.',
        },
        org: {
          title: 'Estrutura da organização',
          subtitle: 'Departamentos, locais e centros de custo a que os seus colaboradores pertencem.',
          departments: 'Departamentos',
          locations: 'Locais',
          costCenters: 'Centros de custo',
          empty: 'Ainda nenhum',
          addDepartment: 'Novo departamento',
          addLocation: 'Novo local, p. ex. Lisboa',
          addCostCenter: 'Novo centro de custo',
        },
      },
      finish: {
        cta: 'Concluir configuração',
        step: 'Conclusão',
        title: 'Conclua a sua configuração',
        body: 'Ao concluir, as suas respostas são aplicadas. Pode alterar tudo mais tarde em cada módulo.',
        nextTitle: 'A seguir: convide a sua equipa',
        nextBody: 'Após a configuração, abra a área de administração para convidar os primeiros utilizadores e atribuir as suas funções.',
        demoWarning: 'Ao concluir, a empresa de demonstração e todos os utilizadores convidados durante a exploração são eliminados.',
      },
      sections: {
        ats: {
          title: 'Recrutamento',
          subtitle: 'Configure o funcionamento das candidaturas e dos e-mails de recrutamento.',
          fields: {
            fromName: { label: 'Nome do remetente', hint: 'Apresentado nos e-mails para candidatos.' },
            signature: { label: 'Assinatura de e-mail', hint: 'Acrescentada aos e-mails enviados a candidatos.' },
          },
          jobPosting: {
            title: 'Anúncio de emprego',
            hint: 'O contacto de candidatura e o logótipo apresentados nos anúncios de emprego externos (opcional — também pode configurar isto mais tarde).',
            contactName: 'Nome do contacto',
            contactEmail: 'E-mail de contacto',
            logo: 'Logótipo do anúncio',
            uploadLogo: 'Carregar logótipo',
            removeLogo: 'Remover',
            rePick: 'O seu logótipo ainda não foi carregado — selecione-o novamente.',
            contactEmailInvalid: 'Introduza um endereço de e-mail válido.',
          },
          workflow: {
            title: 'Processo de contratação',
            participantsQuestion: 'Quem está envolvido nos anúncios de vaga e nas candidaturas?',
            worksCouncil: 'Comissão de trabalhadores',
            sbv: 'Representação dos colaboradores com deficiência',
            legalSignOff: 'Departamento jurídico – aprova um anúncio de vaga antes da publicação',
            assessmentCentreQuestion: 'Utilizam centros de avaliação?',
            assessmentCentre: 'Sim, utilizamos centros de avaliação',
            hint: 'Pode editar e atualizar o processo mais tarde, em qualquer momento, no ATS.',
          },
        },
        time_tracking: {
          title: 'Tempo',
          subtitle: 'Tipos de registo e regras de tempo de trabalho.',
          fields: {
            bookingTypes: { label: 'Tipos de registo', hint: 'Adicione os tipos de registo que utiliza.', placeholder: 'p. ex. Trabalho' },
          },
          companyHolidays: {
            title: 'Férias da empresa',
            hint: 'Dias em que a empresa está encerrada – por exemplo, meio dia na véspera de Natal e na véspera de Ano Novo. Nesses dias não contam horas previstas. Em cada entrada decide se é descontada das férias; pode alterá-lo mais tarde nas definições de Tempo.',
            empty: 'Ainda não há férias da empresa registadas.',
            suggestions: 'Sugestões:',
            christmasEve: 'Véspera de Natal',
            newYearsEve: 'Véspera de Ano Novo',
            name: 'Designação',
            namePlaceholder: 'p. ex. Entre o Natal e o Ano Novo',
            from: 'De',
            to: 'Até (opcional)',
            halfDay: 'Meio dia',
            yearly: 'Todos os anos',
            deductsFromLeave: 'Descontar das férias',
            rangeReversed: 'A data de fim é anterior à data de início.',
          },
        },
        apprenticeship: {
          title: 'Ausbildung',
          subtitle: 'Profissões de formação.',
          fields: {
            professions: { label: 'Profissões de formação', hint: 'As profissões de aprendizagem em que forma.', placeholder: 'p. ex. Técnico/a de informática' },
          },
        },
        people: {
          title: 'Pessoal',
          subtitle: 'Vocabulário partilhado usado em toda a suite.',
          fields: {
            salutations: { label: 'Formas de tratamento', hint: 'Adicione formas de tratamento além do conjunto padrão.', placeholder: 'p. ex. Mx' },
            contractTypes: { label: 'Tipos de contrato', hint: 'Adicione tipos de contrato além do conjunto padrão.', placeholder: 'p. ex. Trabalhador-estudante' },
            workTimeModels: { label: 'Modelos de tempo de trabalho', hint: 'Adicione modelos além do conjunto padrão.', placeholder: 'p. ex. Partilha de posto' },
            workLocationTypes: { label: 'Locais de trabalho', hint: 'Adicione tipos de local de trabalho além do conjunto padrão.', placeholder: 'p. ex. Trabalho no exterior' },
          },
        },
      },
    },
    commit: {
      wiping: {
        title: 'A limpar a demonstração…',
        body: 'A remover a empresa de demonstração para que a sua configuração real comece limpa.',
      },
      applying: {
        title: 'A configurar a sua suite…',
        body: 'A aplicar as suas respostas. Demora apenas um momento.',
      },
      steps: {
        company: 'Perfil da empresa',
      },
      error: 'Ocorreu um problema ao aplicar a sua configuração.',
      retry: 'Tentar novamente',
      backToSetup: 'Voltar à configuração',
      skipStep: 'Concluir sem este passo',
      skipped: 'Ignorado: {steps}. Pode configurar isto em qualquer momento nas definições.',
      resume: 'Retomar configuração',
      stalled: 'Está a demorar mais do que o esperado.',
      wipeFailed: 'Não foi possível limpar a demonstração. Tente novamente para continuar.',
      logoMissing: 'O seu logótipo não foi carregado (perdido ao recarregar) — pode adicioná-lo mais tarde nas definições de anúncios de emprego.',
      workflowFailed: 'Não foi possível gerar a cadeia de contratação, pelo que o espaço de trabalho começa com a cadeia padrão. Tudo o resto foi aplicado — abra as definições de workflow em Recrutamento para executar o gerador novamente.',
      workflowDrafted: "O teu processo de recrutamento foi guardado como rascunho porque {roles} ainda não tem ninguém atribuído. Abre as definições de workflow em Recrutamento para o ativar assim que a função estiver preenchida.",
      workflowRoles: {
        ats_works_council: "a comissão de trabalhadores",
        ats_sbv: "a representação das pessoas com deficiência",
        ats_legal: "o departamento jurídico",
      },
      continue: 'Continuar para o espaço de trabalho',
    },
  },
  tenants: {
    switcherLabel: 'Mudar de espaço de trabalho',
    supportAccessBadge: 'Suporte',
    supportAccessUntil: 'Acesso temporário de suporte até {until}',
    supportAccessBanner: 'O suporte lumi tem atualmente acesso temporário a este espaço.',
    supportAccessReview: 'Analisar',
  },
  dataProtection: {
    blockedErasure: {
      title: 'O que bloqueia uma eliminação',
      intro: 'Os documentos do processo individual sem prazo de conservação ficam guardados por tempo indeterminado: ninguém decidiu durante quanto tempo devem ser conservados, e um documento sem decisão nunca é eliminado automaticamente. Estão listados aqui para que os prazos possam ser definidos.',
      sensitivePlaceholder: 'Documento sensível',
      categories: {
        contract: 'Contrato',
        contract_amendment: 'Alteração ao contrato',
        certificate: 'Certificado',
        attestation: 'Declaração',
        warning: 'Advertência',
        other: 'Outro documento',
      },
      outcomes: {
        refused: 'Eliminação recusada',
        partial: 'Eliminado parcialmente',
      },
      list: {
        title: 'Documentos sem prazo de conservação',
        fixHint: 'Os mais antigos aparecem primeiro. Defina um prazo de conservação no documento do processo individual e ele sai desta lista.',
        loading: 'A carregar documentos…',
        loadError: 'Não foi possível carregar a lista. Tente novamente — isto não significa «nada encontrado».',
        empty: 'Todos os documentos deste espaço de trabalho têm prazo de conservação.',
        uploadedLabel: 'Carregado em',
        truncated: 'São mostrados apenas os {count} documentos mais antigos. Outros aguardam um prazo de conservação.',
      },
    },
    myData: {
      title: 'Os meus dados',
      intro: 'Aqui pode perguntar que dados este espaço de trabalho guarda a seu respeito, pedir a sua retificação ou pedir o seu apagamento. Cada pedido fica registado e é respondido pelas pessoas responsáveis pela proteção de dados neste espaço, e pode ser acompanhado aqui.',
      requests: {
        title: 'Os meus pedidos',
        loading: 'A carregar os seus pedidos…',
        loadError: 'Não foi possível carregar os seus pedidos. Ainda assim, pode fazer um pedido abaixo.',
        empty: 'Ainda não fez nenhum pedido.',
        filedLabel: 'Feito em',
        dueLabel: 'Resposta prevista',
        outcomeLabel: 'Resultado',
        awaitingRelease: 'Cópia em verificação',
      },
      kinds: {
        access: 'Cópia dos meus dados',
        rectification: 'Retificação',
        erasure: 'Apagamento',
      },
      statuses: {
        received: 'Recebido',
        verifying: 'A verificar a identidade',
        in_progress: 'Em tratamento',
        awaiting_subject: 'A aguardar a sua resposta',
        completed: 'Concluído',
        refused: 'Recusado',
        withdrawn: 'Retirado',
      },
      outcomes: {
        erased: 'Dados apagados',
        suppressed: 'Dados apagados, fica um registo mínimo',
        refused: 'Recusado',
        partial: 'Parcialmente tratado',
        answered: 'Respondido',
      },
      actions: {
        access: {
          title: 'Pedir uma cópia dos meus dados',
          body: 'Pode pedir uma cópia dos dados que este espaço de trabalho guarda a seu respeito. Não é uma transferência imediata: a cópia é primeiro preparada e é avisado assim que estiver pronta.',
          where: 'Uma cópia pronta nunca é enviada como anexo de e-mail. Recebe um e-mail, inicia sessão na sua conta lumi HR e transfere-a a partir dessa conta.',
          cta: 'Pedir uma cópia',
          detailLabel: 'Algo a acrescentar (opcional)',
          detailHint: 'Por exemplo, se pretender apenas uma parte dos seus dados.',
        },
        rectification: {
          title: 'Pedir uma retificação',
          body: 'Se algo que este espaço de trabalho guarda a seu respeito estiver incorreto ou desatualizado, pode pedir a sua retificação.',
          cta: 'Pedir uma retificação',
          detailLabel: 'O que está incorreto e o que deveria dizer?',
          detailHint: 'Descreva os dados com o maior rigor possível, para que possam ser encontrados e verificados.',
          selfTitle: 'Parte destes dados pode alterar por si próprio',
          selfFields: 'O seu nome e a forma de tratamento, o seu género, o seu e-mail de contacto, o seu telefone, a sua morada, a sua nacionalidade, o seu estado civil e o seu idioma são alterados no seu perfil.',
          selfLink: 'Abrir o meu perfil',
          askBody: 'Para tudo o resto – data de nascimento, número de colaborador, dados de contrato, de remuneração ou fiscais, os seus documentos – utilize o pedido abaixo.',
        },
        erasure: {
          title: 'Pedir o apagamento dos meus dados',
          body: 'Pode pedir a este espaço de trabalho que apague os dados que guarda a seu respeito.',
          cta: 'Pedir o apagamento',
          confirm: 'O seu pedido é analisado pelas pessoas responsáveis neste espaço de trabalho. Os dados que têm de ser conservados por lei, ou que ainda são necessários para a sua relação de trabalho, não podem ser apagados. Ser-lhe-á comunicado o que foi apagado e o que se mantém.',
          detailLabel: 'Algo a acrescentar (opcional)',
          detailHint: 'Por exemplo, a que dados se refere, caso não sejam todos.',
        },
      },
      form: {
        submit: 'Enviar pedido',
        submitting: 'A enviar…',
        cancel: 'Cancelar',
        success: 'O seu pedido ficou registado. Encontra-o acima, em «Os meus pedidos».',
        errorGeneric: 'Não foi possível enviar o seu pedido. Nada ficou registado — tentar novamente.',
        errorRateLimit: 'Foram enviados vários pedidos em pouco tempo. Tentar novamente mais tarde.',
      },
    },
    export: {
      title: 'Exportar este espaço de trabalho',
      intro: 'É possível descarregar a qualquer momento uma cópia completa de tudo o que este espaço de trabalho guarda, num formato legível por máquina e sem ser preciso pedir-nos.',
      contents: {
        title: 'O que está neste ficheiro',
        body: 'O arquivo contém os dados de todas as pessoas em texto legível e, ao lado deles, as chaves de acesso ativas deste espaço de trabalho: a chave de IA, as ligações de calendário com os respetivos tokens e as credenciais dos fornecedores ligados. O arquivo inclui também, para Pessoal, Recrutamento e Tempo, um documento HR Open Standards (HR-JSON) — o formato partilhado para levar os dados para outro fornecedor.',
        handling: 'Deve ser guardado com o mesmo cuidado que essas chaves. Quem tiver o ficheiro e a palavra-passe tem tudo o que ele contém.',
      },
      roleRequired: {
        title: 'Esta exportação exige a função «Proteção de dados»',
        body: 'O arquivo contém todos os ficheiros guardados neste espaço de trabalho — recibos de vencimento, atestados médicos e documentos de identificação incluídos — a par dos dados pessoais de todas as pessoas e das chaves de acesso ativas deste espaço de trabalho.',
        hint: 'Ser proprietário do espaço de trabalho já não chega: quem inicia a exportação tem também de ter a função «Proteção de dados». Essa função é atribuída juntamente com as restantes funções da suite na administração de utilizadores e também pode ser atribuída a si.',
      },
      start: {
        title: 'Iniciar uma exportação',
        body: 'É necessário escolher uma palavra-passe. O arquivo é cifrado com ela e só com ela pode ser aberto.',
        passphraseWarning: 'A palavra-passe nunca é guardada e não pode ser recuperada. Se for perdida, o arquivo deixa de poder ser aberto — não existe forma de a repor.',
        passphraseLabel: 'Palavra-passe',
        passphraseHint: 'Pelo menos {min} caracteres. Convém ser algo longo, guardado em local seguro.',
        confirmLabel: 'Repetir a palavra-passe',
        submit: 'Iniciar exportação',
        submitting: 'A iniciar…',
        success: 'A exportação foi iniciada. É preparada em segundo plano e aparece abaixo assim que estiver pronta.',
        errorTooShort: 'A palavra-passe precisa de pelo menos {min} caracteres.',
        errorMismatch: 'As duas palavras-passe não coincidem.',
        errorAlreadyRunning: 'Já está em curso uma exportação deste espaço de trabalho. É preciso esperar que termine antes de iniciar outra.',
        errorTooMany: 'Este espaço de trabalho iniciou, por agora, o número máximo de exportações. Convém tentar novamente mais tarde.',
        errorGeneric: 'Não foi possível confirmar se a exportação foi iniciada. É favor verificar a lista abaixo antes de iniciar outra.',
      },
      list: {
        title: 'Exportações deste espaço de trabalho',
        loading: 'A carregar as exportações…',
        loadError: 'Não foi possível carregar as exportações.',
        empty: 'Este espaço de trabalho ainda não foi exportado.',
        linkHint: 'Uma ligação de descarga só é válida por instantes. Se deixar de funcionar, basta usar novamente o botão.',
        retentionHint: 'Cada arquivo é eliminado automaticamente quando expira — a data é indicada ao lado.',
        startedLabel: 'Iniciada',
        expiresLabel: 'Disponível até',
        download: 'Descarregar',
        preparing: 'A preparar…',
        downloadError: 'Não foi possível preparar a descarga. O arquivo pode já não existir.',
        gone: 'O arquivo foi eliminado. É preciso iniciar uma nova exportação para obter outra cópia.',
        failedHint: 'Esta exportação não chegou ao fim. Pode ser iniciada uma nova.',
        runningHint: 'Esta exportação ainda está a ser preparada.',
      },
      statuses: {
        requested: 'Pedida',
        exporting: 'Em preparação',
        exported: 'Pronta',
        failed: 'Falhou',
        expired: 'Eliminada',
      },
    },
    settingsPanel: {
      title: 'Tratamento de dados',
      body: 'É possível pedir a eliminação ou a correção dos seus dados, ou solicitar uma cópia, {link}.',
      linkLabel: 'aqui',
    },
  },
  // Administration › Data subject requests (issue 789): the DSAR work list.
  dataRequests: {
    forbidden: {
      title: 'Esta lista é para a função de proteção de dados',
      description: 'Os pedidos dos titulares dos dados são tratados pelo proprietário da área de trabalho ou por quem tem a função «Proteção de dados».',
    },
    intro: {
      title: 'Pedidos dos titulares dos dados',
      body: 'Pedidos de pessoas sobre os dados que esta área de trabalho guarda sobre elas. Cada pedido tem de ser respondido no prazo de um mês a contar da receção (art. 12.º, n.º 3 do RGPD). Se o pedido for complexo, o prazo pode ser prorrogado duas vezes por um mês, com um motivo que tem de ser comunicado à pessoa.',
    },
    filters: {
      label: 'Mostrar pedidos',
      open: 'Em aberto',
      overdue: 'Fora de prazo',
      dueSoon: 'Prazo nos próximos 7 dias',
      closed: 'Respondidos recentemente',
    },
    empty: {
      title: 'Sem pedidos dos titulares dos dados',
      description: 'Quando alguém perguntar pelos seus dados — no lumi, por e-mail, correio ou telefone — o pedido aparece aqui com o respetivo prazo.',
    },
    emptyFilter: 'Não há pedidos nesta vista.',
    truncated: 'Nem todos os pedidos cabem nesta página. Os prazos mais próximos aparecem primeiro.',
    badges: {
      overdue: 'Fora de prazo',
      dueSoon: 'Prazo próximo',
      legalHold: 'Dever de conservação',
      reviewReady: 'Pronto para revisão',
      reviewReleased: 'Libertada',
      reviewDelivered: 'Entregue',
    },
    row: {
      received: 'Recebido',
      due: 'Resposta até',
      closed: 'Encerrado',
      subject: 'Diz respeito a',
      channel: 'Chegou por',
      outcome: 'Resultado',
      extensions: 'Prazo prorrogado {count} de 2 vezes',
      postponed: 'Lembretes suspensos até {date}',
      vetoWindow: 'O apagamento ainda pode ser travado até {date}',
      reviewFlagged: 'É necessária uma decisão: {flagged} de {total} entradas',
      reviewNoneFlagged: 'Nenhuma entrada assinalada',
      reviewEmpty: 'A cópia não contém entradas',
      reviewOpen: 'Rever',
      reviewReleased: 'Libertada, em entrega',
      reviewDelivered: 'Entregue, em encerramento',
    },
    legalHold: {
      tenant: 'Aplica-se um dever de conservação a toda a área de trabalho ({reason}).',
      subject: 'Um dever de conservação abrange esta pessoa ({reason}).',
      consequence: 'Os dados não podem ser apagados. A resposta lícita é uma recusa que nomeia esse fundamento — o dever não suspende o prazo.',
    },
    automated: {
      pending: 'O lumi responde a este pedido por si: depois de verificar a identidade da pessoa e passar o pedido para «Em tratamento», o lumi prepara a cópia dos seus dados. Esta fica depois à espera da sua revisão. Depois de a libertar, a pessoa é informada de onde a pode descarregar e o pedido encerra-se sozinho.',
      running: 'O lumi está a preparar a cópia dos dados desta pessoa. Fica depois à espera da sua revisão — a pessoa só é informada de onde a descarregar depois de a libertar.',
    },
    detail: {
      show: 'Ver quem fez o pedido',
      hide: 'Ocultar detalhes',
      loading: 'A carregar detalhes…',
      loadError: 'Não foi possível carregar os detalhes deste pedido.',
      subjectLabel: 'Nome indicado',
      subjectEmail: 'Endereço de e-mail',
      subjectPhone: 'Número de telefone',
      requestDetail: 'O que foi pedido',
      onBehalfReason: 'Registado em seu nome porque',
      extensionReason: 'Motivo da prorrogação',
      outcomeBasis: 'Fundamento indicado',
      nothingOnFile: 'Contacto',
      nothingOnFileValue: 'Não há nome, endereço nem mensagem registados para este pedido.',
    },
    kinds: {
      access: 'Cópia dos seus dados',
      rectification: 'Retificação',
      erasure: 'Apagamento',
      restriction: 'Limitação do tratamento',
      portability: 'Portabilidade dos dados',
      objection: 'Oposição ao tratamento',
    },
    statuses: {
      received: 'Recebido',
      verifying: 'Identidade em verificação',
      in_progress: 'Em tratamento',
      awaiting_subject: 'A aguardar a pessoa',
      completed: 'Concluído',
      refused: 'Recusado',
      withdrawn: 'Retirado',
    },
    outcomes: {
      erased: 'Dados apagados',
      suppressed: 'Dados apagados, registo mínimo mantido',
      refused: 'Recusado',
      partial: 'Tratado em parte',
      answered: 'Respondido na íntegra',
    },
    subjectTypes: {
      person: 'Um processo de colaborador',
      tenant_user: 'Um membro sem processo de colaborador',
      candidate: 'Um candidato',
      unlinked: 'Não associado a nenhum registo',
    },
    channels: {
      'self-service': 'Apresentado no lumi pela pessoa',
      'candidate-portal': 'Portal de candidatos',
      email: 'E-mail',
      post: 'Correio',
      phone: 'Telefone',
      unknown: 'Não registado',
    },
    actions: {
      advance: {
        verifying: 'Verificar a identidade',
        in_progress: 'Começar a tratar',
        awaiting_subject: 'Aguardar a pessoa',
      },
      extend: 'Prorrogar o prazo',
      close: 'Encerrar o pedido',
      postpone: 'Pausar lembretes',
      veto: 'Abrir prazo de veto',
      hold: 'Conservar desta pessoa',
      restrict: 'Limitar o tratamento',
      record: 'Registar um pedido',
    },
    confirmAutomated: {
      title: 'Preparar a cópia dos dados desta pessoa?',
      body: 'Ao passar o pedido para «Em tratamento», encarrega o lumi de reunir tudo o que esta área de trabalho guarda sobre a pessoa. A cópia ainda não segue para a pessoa: fica à espera da sua revisão, e a pessoa só é informada de onde a descarregar depois de a libertar. Faça-o apenas quando a identidade estiver confirmada.',
      confirm: 'Começar',
    },
    toast: {
      advanced: 'Pedido passado para «{status}».',
      extended: 'Prazo prorrogado até {date}.',
      closed: 'Pedido encerrado.',
      postponed: 'Lembretes pausados até {date}.',
      vetoOpened: 'Prazo de veto aberto. O apagamento aguarda 72 horas.',
      holdPlaced: 'Dever de conservação definido.',
      holdReleased: 'Dever de conservação levantado.',
      holdAttested: 'Dever de conservação confirmado por mais seis meses.',
      restrictionPlaced: 'Tratamento limitado.',
      restrictionNotified: 'Comunicação registada.',
      restrictionLifted: 'Limitação levantada.',
      recorded: 'Pedido registado.',
    },
    extend: {
      title: 'Prorrogar o prazo',
      body: 'O art. 12.º, n.º 3 do RGPD permite duas prorrogações de um mês quando o pedido é complexo ou os pedidos são muitos. Informe a pessoa no primeiro mês, com o motivo.',
      remaining: 'Prorrogações restantes: {count}',
      reasonLabel: 'Motivo do atraso',
      reasonHint: 'Fica registado com o pedido. Dê à pessoa o mesmo motivo.',
      submit: 'Prorrogar um mês',
      errorReason: 'Indique o motivo do atraso.',
    },
    close: {
      title: 'Encerrar o pedido',
      body: 'Um pedido encerrado não pode ser reaberto: é o registo de como e quando a área de trabalho respondeu.',
      statusLabel: 'Como foi encerrado?',
      outcomeLabel: 'O que foi feito',
      outcomePlaceholder: 'Escolher…',
      basisLabel: 'Fundamento jurídico',
      basisHint: 'O fundamento do que foi conservado ou recusado, por exemplo um dever de conservação ou o art. 12.º, n.º 5 do RGPD.',
      submit: 'Encerrar o pedido',
      errorOutcome: 'Escolha o que foi feito.',
      errorBasis: 'Uma recusa ou uma resposta parcial tem de indicar o fundamento jurídico.',
      conflict: 'Não foi possível encerrar o pedido desta forma. Um dever de conservação ou uma janela de veto aberta pode impedir o apagamento dos dados, ou o pedido mudou entretanto — recarregue a lista e verifique.',
    },
    record: {
      title: 'Registar um pedido',
      body: 'Para um pedido que chegou por e-mail, correio ou telefone. O prazo de um mês conta a partir do dia em que chegou, não de hoje. Um pedido registado começa como recebido.',
      choose: 'Escolher…',
      kindLabel: 'Tipo de pedido',
      channelLabel: 'Chegou por',
      receivedLabel: 'Recebido em',
      receivedHint: 'O dia em que o pedido chegou ao espaço de trabalho — no máximo hoje.',
      subjectLabel: 'Pessoa em causa',
      modes: {
        person: 'Uma pessoa em Pessoal',
        candidate: 'Uma candidatura em Recrutamento',
        unlinked: 'Sem registo',
      },
      personLabel: 'Procurar a pessoa',
      personHint: 'Pesquise por nome ou endereço de e-mail.',
      candidateLabel: 'Candidato ou candidata',
      candidateHint: 'Pesquise por nome ou endereço de e-mail. Só aparecem candidatos que a sua função em Recrutamento pode abrir.',
      candidateRefused: 'As suas funções em Recrutamento não permitem pesquisar candidaturas. Escolha «Sem registo» e indique o nome que a pessoa deu.',
      searchPlaceholder: 'Nome ou endereço de e-mail',
      picker: {
        searching: 'A pesquisar…',
        typeMore: 'Pelo menos {count} caracteres',
        noMatch: 'Sem resultados. Se a pessoa não estiver registada em lado nenhum, escolha «Sem registo».',
        error: 'A pesquisa falhou. Se a pessoa não estiver registada em lado nenhum, escolha «Sem registo».',
        refused: 'As suas funções não permitem pesquisar candidaturas.',
        rateLimited: 'Demasiadas pesquisas – já continua',
        resultsAnnouncement: 'Um resultado | {count} resultados',
        clear: 'Limpar seleção',
      },
      nameLabel: 'Nome indicado',
      nameHint: 'Tal como a pessoa assinou ou se apresentou.',
      emailLabel: 'Endereço de e-mail (opcional)',
      detailLabel: 'O que é pedido?',
      detailHint: 'Opcional. Tanto quanto possível, com as palavras da pessoa.',
      reasonLabel: 'Porque o regista em nome da pessoa?',
      reasonHint: 'Por exemplo: carta aos RH de 3 de maio, ou chamada atendida na receção. Fica registado com o seu nome.',
      submit: 'Registar pedido',
      errorKind: 'Escolha o tipo de pedido.',
      errorChannel: 'Escolha como chegou o pedido.',
      errorReceived: 'Escolha o dia em que o pedido chegou.',
      errorFuture: 'Um pedido não pode chegar no futuro. Escolha hoje ou um dia anterior.',
      errorPerson: 'Escolha a pessoa na pesquisa, ou «Sem registo».',
      errorCandidate: 'Escolha a candidatura na pesquisa, ou «Sem registo».',
      errorName: 'Indique o nome que a pessoa deu.',
      errorEmail: 'Introduza um endereço de e-mail válido, ou deixe o campo vazio.',
      errorReason: 'Indique porque regista o pedido em nome da pessoa.',
    },
    errors: {
      conflict: 'Este passo já não é possível — o pedido mudou entretanto. Recarregue a lista.',
      notLinked: 'Este pedido não está associado a nenhum registo, por isso não há ninguém a conservar ou limitar.',
    },
    progress: {
      title: 'Apagamento por módulo',
      show: 'Mostrar o progresso do apagamento',
      hide: 'Ocultar o progresso do apagamento',
      loading: 'A carregar o registo de apagamento…',
      loadError: 'Não foi possível carregar o registo de apagamento.',
      unlinked: 'Este pedido não está associado a nenhum registo, por isso nenhum módulo apagou nada por ele.',
      lastExecuted: 'registado em {date}',
      states: {
        done: 'Apagado',
        heldNothing: 'Não guardava nada',
        pending: 'Ainda não registado',
        deferred: 'Adiado — módulo desativado',
      },
      modules: {
        people: 'Pessoal',
        ats: 'Candidaturas',
        time: 'Tempo',
        apprentice: 'Formação',
        payroll: 'Processamento salarial',
        privacy: 'Registo de proteção de dados',
      },
    },
    postpone: {
      title: 'Pausar os lembretes',
      body: 'Para os e-mails de lembrete até ao dia escolhido. O prazo legal não muda — para o alterar, prorrogue o pedido.',
      untilLabel: 'Pausar até',
      untilHint: 'No máximo até à data-limite de resposta, {date}.',
      reasonLabel: 'Motivo',
      reasonHint: 'Fica registado com o pedido, para que a pausa possa ser justificada mais tarde.',
      submit: 'Pausar lembretes',
      errorUntil: 'Escolha o dia em que os lembretes recomeçam.',
      errorRange: 'Escolha um dia entre amanhã e a data-limite de resposta.',
      errorReason: 'Indique o motivo da pausa.',
    },
    veto: {
      title: 'Abrir o prazo de veto?',
      body: 'Nas próximas 72 horas, o apagamento fica retido: o pedido não pode ser encerrado como apagado. Aproveite para verificar se é necessário um dever de conservação ou uma recusa. O prazo não pode ser encerrado antes.',
      confirm: 'Abrir prazo de veto',
    },
    holds: {
      title: 'Deveres de conservação',
      intro: 'Um dever de conservação impede que os dados sejam apagados — por um pedido, pelas regras de conservação ou pela eliminação da área de trabalho — até ser levantado. Cada dever tem de ser confirmado de novo a cada seis meses.',
      placeTenant: 'Conservar toda a área de trabalho',
      empty: 'Nenhum dever de conservação ativo.',
      lapsedNotice: 'Deveres com a data de confirmação ultrapassada: {count}. Continuam a bloquear o apagamento — confirme-os ou levante-os.',
      scopeTenant: 'Toda a área de trabalho',
      scopeSubject: 'Uma pessoa',
      lapsed: 'Confirmação em atraso',
      placedAt: 'Definido em',
      attestationDue: 'Confirmar até',
      basis: 'Fundamento jurídico',
      attest: 'Ainda necessário',
      attestConfirm: {
        title: 'Manter este dever?',
        body: 'Confirma que o motivo do dever de conservação ainda se aplica. Mantém-se por mais seis meses.',
        confirm: 'Manter dever',
      },
      release: {
        open: 'Levantar',
        title: 'Levantar o dever de conservação',
        warning: 'A partir de agora, os dados protegidos por este dever podem ser apagados — por pedidos em aberto, pelas regras de conservação ou pela eliminação da área de trabalho. Não é possível anular.',
        reasonLabel: 'Porque já não é necessário o dever?',
        reasonHint: 'Fica registado com o seu nome.',
        submit: 'Levantar dever',
        errorReason: 'Indique o motivo do levantamento.',
      },
      place: {
        titleTenant: 'Conservar toda a área de trabalho',
        titleSubject: 'Conservar desta pessoa',
        bodyTenant: 'Enquanto o dever existir, nenhum dado desta área de trabalho pode ser apagado — nem por pedidos, nem pelas regras de conservação, nem pela eliminação da área de trabalho.',
        bodySubject: 'Enquanto o dever existir, nenhum dado da pessoa indicada neste pedido pode ser apagado. O pedido tem mesmo assim de ser respondido dentro do prazo.',
        reasonLabel: 'Motivo',
        reasonHint: 'Por exemplo, o processo judicial ou o pedido de uma autoridade que obriga a conservar os dados.',
        basisLabel: 'Fundamento jurídico (opcional)',
        basisHint: 'Uma referência curta, por exemplo a norma ou o número do processo.',
        submit: 'Definir dever',
        errorReason: 'Indique o motivo do dever de conservação.',
      },
      errors: {
        notActive: 'Este dever já não está ativo — foi alterado entretanto. A lista foi recarregada.',
      },
    },
    restrictions: {
      title: 'Limitações do tratamento',
      intro: 'Um registo limitado pode ser conservado, mas não utilizado (art. 18.º RGPD). Antes de levantar uma limitação, a pessoa tem de ser informada.',
      empty: 'Nenhum tratamento está limitado.',
      originSystem: 'Definida após um apagamento',
      originRequest: 'De um pedido',
      notified: 'Pessoa informada em {date}',
      notNotified: 'Pessoa ainda não informada',
      placedAt: 'Limitado desde {date}',
      notifyOpen: 'Informar a pessoa',
      notifyAgain: 'Registar nova comunicação',
      lift: 'Levantar limitação',
      liftConfirm: {
        title: 'Levantar a limitação?',
        body: 'O registo pode voltar a ser utilizado como antes. A pessoa foi informada.',
        bodySystem: 'Esta limitação foi definida automaticamente sobre o que ficou conservado após o apagamento dos dados da pessoa. Levantá-la torna estes registos novamente editáveis e utilizáveis. Só a levante se a limitação já não for necessária.',
        confirm: 'Levantar limitação',
      },
      errors: {
        notActive: 'Esta limitação já não está ativa, ou a pessoa ainda não foi informada. A lista foi recarregada.',
      },
      place: {
        title: 'Limitar o tratamento',
        body: 'O registo da pessoa indicada neste pedido é conservado, mas deixa de poder ser utilizado até a limitação ser levantada. A limitação fica associada a este pedido.',
        reasonLabel: 'Motivo',
        reasonHint: 'Por exemplo: a pessoa contesta a exatidão dos dados.',
        submit: 'Limitar',
        errorReason: 'Indique o motivo da limitação.',
      },
      notify: {
        title: 'Informar a pessoa',
        body: 'A pessoa tem de ser informada antes de a limitação ser levantada (art. 18.º, n.º 3, RGPD).',
        modeLabel: 'Como é informada a pessoa?',
        modeSend: 'O lumi envia um e-mail',
        modeManual: 'Já informada de outra forma',
        manualOnly: 'Esta limitação não está associada a nenhum pedido, por isso o lumi não tem endereço. Informe a pessoa e registe-o aqui.',
        employerLabel: 'Entidade empregadora indicada no e-mail',
        employerHint: 'A pessoa tem de conseguir ver quem limitou os seus dados.',
        refLabel: 'Referência',
        refHint: 'Como a informou, por exemplo «carta de 3 de maio» ou um número de processo.',
        dateLabel: 'Informada em',
        dateHint: 'Deixe vazio para hoje.',
        submitSend: 'Enviar e-mail',
        submitManual: 'Registar comunicação',
        sendRefused: 'Não foi possível enviar o e-mail: o pedido não contém nenhum endereço de e-mail. Informe a pessoa de outra forma e registe-o.',
        errorEmployer: 'Indique a entidade empregadora.',
        errorRef: 'Indique uma referência da comunicação.',
      },
    },
    review: {
      title: 'Rever a cópia',
      intro: 'É assim que a pessoa vai ler a sua cópia. Cada entrada assinalada é decidida em separado: libertar ou reter (art. 15.º, n.º 4, RGPD). Tudo o resto é só de leitura.',
      back: 'Voltar aos pedidos',
      counter: {
        undecided: 'Faltam decidir {undecided} de {flagged} entradas',
        allDecided: 'Todas as {flagged} entradas assinaladas estão decididas',
        noneFlagged: 'Nenhuma entrada está assinalada — a cópia pode ser libertada logo',
      },
      modules: {
        people: 'Pessoal',
        ats: 'Candidaturas',
        time: 'Tempo',
        apprentice: 'Formação',
      },
      moduleState: {
        notInstalled: 'Este módulo não faz parte desta área de trabalho, pelo que não há nada guardado nele.',
        removed: 'Este módulo foi removido da área de trabalho; não resta nada sobre a pessoa.',
        unavailable: 'Não foi possível contactar este módulo ao preparar a cópia — esta área falta na cópia. Passar o pedido para «Aguardar a pessoa» e depois outra vez para «Começar a tratar» — o lumi prepara então a cópia de novo — ou libertá-la conscientemente sem esta área.',
      },
      moduleEmpty: 'Aqui não há nada guardado sobre a pessoa.',
      delivered: 'Entregue — o lumi encerra o pedido dentro de momentos',
      self: {
        title: 'Este pedido diz respeito a si',
        description: 'Outra pessoa responsável pela proteção de dados tem de rever a cópia. Pode responder ao pedido manualmente.',
      },
      unverified: 'O lumi não conseguiu verificar agora se este pedido diz respeito a si. Tentar novamente dentro de momentos.',
      sectionMeta: 'Tratamento: {activity}',
      flagged: 'Assinalada',
      flagReason: {
        written: 'Escrita por outra pessoa sobre a pessoa em causa, ou refere outras pessoas. Ponderar se a pessoa pode ler esta entrada.',
        generic: 'Pode conter informações sobre outras pessoas ou ter sido escrita por outras. Ponderar segundo o art. 15.º, n.º 4, RGPD.',
      },
      state: {
        undecided: 'Ainda por decidir',
        release: 'Será libertada',
        withhold: 'Será retida',
      },
      decision: {
        group: 'Decisão sobre uma entrada em «{section}»',
        release: 'Libertar',
        withhold: 'Reter',
        changeReason: 'Alterar o motivo',
        reasonLabel: 'Motivo para a pessoa',
        reasonHint: 'A pessoa lê este motivo na sua cópia. Escrevê-lo para ela e não repetir o conteúdo da entrada.',
        reasonSave: 'Guardar como retida',
        reasonRequired: 'Indicar um motivo.',
        saveError: 'Não foi possível guardar a decisão. A entrada mantém o estado anterior.',
      },
      release: {
        action: 'Libertar a cópia',
        blocked: 'Decidir primeiro as {undecided} entradas assinaladas em aberto; depois a cópia pode ser libertada.',
        confirmTitle: 'Libertar a cópia?',
        confirmBody: 'O lumi cria agora a cópia sem as entradas retidas ({withheld}), avisa a pessoa e encerra o pedido.',
        confirmBodyNone: 'O lumi cria agora a cópia, avisa a pessoa e encerra o pedido.',
        confirmLabel: 'Libertar',
        done: 'Libertada — o lumi entrega a cópia',
      },
      errors: {
        undecided: 'Ainda há entradas assinaladas em aberto. A página foi recarregada.',
        expired: 'A cópia expirou — o lumi cria uma nova e voltará a vê-la aqui em breve',
        closed: 'O pedido já não está aberto. A cópia já não pode ser libertada.',
      },
      notFound: {
        title: 'Aqui não está nenhuma cópia à espera',
        description: 'A cópia expirou ou já foi entregue. Se o pedido ainda estiver aberto, o lumi cria uma nova e voltará a vê-la em breve na lista.',
      },
    },
  },
  legalNotices: {
    title: 'Aviso de privacidade e IA para colaboradores',
    intro: 'O que este workspace comunica aos seus colaboradores sobre privacidade e o uso de IA no trabalho.',
    titleLabel: 'Título',
    contentLabel: 'Texto do aviso',
    editMode: 'Editar',
    previewMode: 'Pré-visualizar',
    followingVersion: 'A seguir a versão lumi {version}',
    branchedFromVersion: 'Texto próprio (derivado da versão {version} em {date})',
    updateAvailable: 'Está disponível uma versão lumi mais recente ({version}).',
    compareVersions: 'Comparar',
    hideComparison: 'Ocultar comparação',
    yourText: 'O seu texto',
    lumiVersionHeading: 'Versão lumi {version}',
    adoptVersion: 'Adotar versão {version}',
    adoptConfirm: 'Substituir o seu texto em ambos os idiomas pela versão {version} da lumi?',
    adopted: 'Versão da lumi adotada.',
    saved: 'Guardado.',
    noticeRequired: 'O aviso não pode ser guardado vazio.',
    lumiVersionUnavailable: 'Não foi possível contactar a versão atual da lumi — tente novamente em breve.',
    forbidden: 'Não tem acesso a este aviso.',
    supportRefused: 'Uma sessão de suporte não dá acesso a este aviso.',
    membershipUnavailable: 'Não foi possível verificar o seu acesso agora — tente novamente em breve.',
    loadFailed: 'Não foi possível carregar o aviso.',
    compareUnavailable: 'Não foi possível contactar a lumi, pelo que a comparação e Adotar não estão disponíveis agora.',
    blanksOpenRefusal: 'O texto ainda contém lacunas por preencher: {list}. Preencha-as acima, ou substitua-as por texto próprio, antes de guardar.',
    unsavedWarning: 'As alterações em {name} ainda não foram guardadas.',
    demoDisclaimer: 'ESTA É A VERSÃO DE DEMONSTRAÇÃO PARA UMA EMPRESA DE DEMONSTRAÇÃO FICTÍCIA. NÃO É UM DOCUMENTO JURIDICAMENTE VINCULATIVO.',
    blanks: {
      lead: 'Os modelos da lumi precisam destes dados. Indique cada um uma só vez: é inserido em todos os textos abaixo, nos dois idiomas.',
      saved: 'Guardado.',
      complete: 'Todas as informações necessárias foram fornecidas.',
      suggested: 'Tirada do perfil da empresa – confirme e guarde.',
      keys: {
        company_name: { label: 'Nome da empresa', hint: 'O nome legal deste workspace, tal como deve aparecer no aviso.' },
        company_address: { label: 'Morada da empresa', hint: 'A morada postal onde colaboradores e candidatos podem entrar em contacto.' },
        privacy_contact: { label: 'Contacto de proteção de dados', hint: 'A quem perguntar sobre proteção de dados — um nome, uma função ou um endereço de email.' },
        applicant_retention: { label: 'Prazo de conservação dos dados de candidatura', hint: 'Durante quanto tempo as candidaturas não selecionadas são conservadas antes de serem eliminadas.' },
      },
    },
    // The page's two-step checklist (issue 766): the facts form, then the imprint.
    checklist: {
      title: 'Para os textos legais ficarem completos',
      progress: '{done} de {total} concluído(s)',
      facts: { title: 'Dados para todos os textos', hint: 'Nome da empresa, morada, contacto de proteção de dados e mais — inseridos em cada texto abaixo.' },
      imprintAction: 'Preencher a informação legal',
    },
    candidate: {
      heading: 'Avisos para candidatos',
      intro: 'Os avisos legais que este espaço de trabalho mostra às pessoas candidatas no portal de carreiras.',
      unavailable: 'Os avisos para candidatos não estão disponíveis neste momento.',
      noticeRequired: 'Este aviso é mostrado a quem se candidata e não pode ficar vazio. Substitua o texto ou adote a versão da lumi.',
      imprintRequired: 'A informação legal não pode ser esvaziada enquanto o portal estiver online. Substituir o texto em vez de o eliminar.',
      privacy: {
        title: 'Aviso de privacidade do inquilino',
        subtitle: 'Esta versão é apresentada no portal para candidatos.',
      },
      aiUsage: {
        title: 'Informação sobre a utilização de IA para candidatos',
        subtitle: 'Este texto é apresentado aos candidatos no portal de carreiras.',
      },
      imprint: {
        title: 'Informação legal do portal de carreiras',
        subtitle: 'Este texto é ligado a partir de todas as páginas do portal.',
        hint: 'A informação legal é obrigatória por lei (§ 5 DDG). O portal de carreiras permanece offline enquanto não estiver guardada em nenhum idioma.',
        fallsBack: 'A informação legal está guardada. Os idiomas sem informação legal própria mostram no portal a versão {language}.',
      },
      history: {
        title: 'O que foi apresentado numa determinada data?',
        hint: 'Consultar o texto exato que esta página tinha num momento passado — para a pergunta de uma pessoa candidata ou de uma autoridade.',
        open: 'Consultar',
        hide: 'Fechar',
        dateLabel: 'Data e hora',
        localeLabel: 'Idioma',
        lookUp: 'Mostrar o texto',
        periodClosed: 'Publicado de {from} até {until}.',
        periodOpen: 'Publicado desde {from} — ainda é o texto atual.',
        sourceLumi: 'A versão {version} publicada pela lumi, palavra por palavra.',
        sourceLumiUnversioned: 'O texto publicado pela lumi.',
        sourceTenant: 'O texto próprio deste espaço de trabalho, derivado da versão {version} da lumi.',
        sourceTenantOwn: 'O texto próprio deste espaço de trabalho.',
        none: 'O registo não recua até essa data.',
        provenanceFollowing: 'O que está registado: esta página é uma cópia da versão {version} da lumi e nunca foi reescrita aqui.',
        provenanceBranched: 'O que está registado: esta página provém da versão {version} da lumi e foi reescrita em {date}.',
        provenanceUnknown: 'Nada mais está registado sobre esta página no período anterior.',
        futureRefused: 'Este registo diz o que uma página apresentou, não o que irá apresentar. Selecionar um momento já passado.',
        invalidRefused: 'Selecionar uma data e um idioma para a consulta.',
        failed: 'Não foi possível ler o registo neste momento. Tentar novamente.',
      },
    },
  },
  legalNoticePublic: {
    unavailable: 'Este aviso não está disponível neste momento.',
  },
  dataImportHub: {
    nav: 'Importação de dados',
    title: 'Importação e exportação de dados',
    intro: 'Importe e exporte dados existentes para os módulos a partir de um único lugar. Cada ação corre no módulo de destino com a sua permissão.',
    locked: 'Sem permissão neste módulo',
    lockedDetail: 'Falta-lhe a permissão de importação (data_import.manage) em {module}. Peça a um admin do módulo.',
    plan: {
      title: 'Plano de importação',
      run: 'Criar agora os valores em falta',
      summary: 'Faltam {count} valores em {module} e podem ser criados lá como importação.',
      truncated: 'Lista truncada — são detetados até 200 valores em falta por campo.',
      forbidden: 'Falta-lhe a permissão em {module}.',
      running: 'Importação companion em curso…',
      waiting: 'A aguardar que os novos valores cheguem ao módulo de destino…',
      rerunning: 'A repetir o ensaio no módulo de destino…',
      done: 'Concluído — o ensaio usa os novos valores.',
      failed: 'A importação companion falhou.',
      confirmTitle: 'Criar os valores em falta?',
      confirmBody: 'Faltam {count} valores em {module}. Criá-los agora via importação? O ensaio reinicia automaticamente depois.',
      companionErrors: 'O ensaio companion reporta erros — verifique no módulo.',
      projectionTimeout: 'A projeção para o módulo de destino demora mais do que o esperado — tente novamente mais tarde.',
    },
    createField: {
      title: 'Criar novo campo personalizado',
      intro: 'Crie um campo personalizado para a coluna “{column}”. Ficará depois disponível em todo o ATS.',
      typeHint: 'Campos de escolha (select/seleção múltipla) são criados na gestão de campos.',
      sensitiveNotImportable: 'Campos de categorias especiais (art. 9) são criados, mas deliberadamente não são destino de importação.',
      submit: 'Criar campo',
      label: 'Etiqueta',
      keyLabel: 'Chave do campo (Key)',
      keyHint: 'Apenas letras minúsculas, números e underscores',
      typeLabel: 'Tipo',
      types: {
        text: 'Texto',
        textarea: 'Área de texto',
        number: 'Número',
        date: 'Data',
        checkbox: 'Caixa de verificação',
      },
      sensitivityLabel: 'Que tipo de dados contém este campo?',
      sensitivityUnanswered: 'Selecionar uma opção',
      sensitivityNone: 'Nenhuma categoria especial',
      sensitivityHint: 'Os dados de categorias especiais (art. 9.º RGPD) não podem desencadear decisões automatizadas sobre uma candidatura.',
      sensitivityCategories: {
        racialEthnic: 'Origem racial ou étnica',
        politicalOpinion: 'Opiniões políticas',
        religiousPhilosophical: 'Convicções religiosas ou filosóficas',
        tradeUnion: 'Filiação sindical',
        genetic: 'Dados genéticos',
        biometricId: 'Identificação biométrica',
        health: 'Dados de saúde',
        sexLifeOrientation: 'Vida sexual ou orientação sexual',
      },
      sensitivityRequired: 'Indique que tipo de dados contém este campo.',
    },
    entities: {
      person: 'Colaboradores',
      orgUnit: 'Unidades org.',
      employmentContract: 'Contratos',
      job: 'Vagas',
      candidate: 'Candidatos',
      application: 'Candidaturas',
      client: 'Clientes',
      project: 'Projetos',
      timeEntry: 'Registos de tempo',
      leaveRequest: 'Ausências',
    },
    // People's enum values in the words People uses for them (people-ui's own
    // labels): the import wizard names allowed values with these.
    peopleValues: {
      contractType: {
        permanent: 'sem termo',
        fixed_term: 'a termo certo',
        mini_job: 'mini-job',
        midi_job: 'midi-job (faixa de transição)',
        working_student: 'trabalhador-estudante',
        apprenticeship: 'aprendizagem',
        internship: 'estágio',
        freelance: 'prestação de serviços / recibos verdes',
        managing_director: 'gerente / administrador',
        other: 'outro',
      },
      workTimeArrangement: {
        full_time: 'tempo inteiro',
        part_time: 'tempo parcial',
        marginal: 'marginal (mini-job)',
        variable: 'variável / flexível',
      },
      status: {
        draft: 'Rascunho',
        active: 'Ativo',
        on_hold: 'Em pausa',
        terminated: 'Cessado',
        inactive: 'Inativo',
      },
      type: {
        department: 'Departamento',
        location: 'Localização',
        team: 'Equipa',
        cost_center: 'Centro de custos',
      },
    },
    // People's import fields in People's own words (people-ui's labels), per
    // entity: the wizard's row errors name a field with these, never by its key.
    peopleFields: {
      orgUnit: {
        externalId: 'ID externo',
        type: 'Tipo',
        name: 'Nome',
        code: 'Código',
        description: 'Descrição',
        parentExternalId: 'Unidade superior',
        parentCode: 'Unidade superior (Código)',
        addressLine1: 'Morada',
        postalCode: 'Código postal',
        city: 'Localidade',
        country: 'País',
        active: 'Ativo',
      },
      person: {
        externalId: 'ID externo',
        employeeNumber: 'Número de funcionário',
        firstName: 'Nome próprio',
        lastName: 'Apelido',
        salutation: 'Forma de tratamento',
        gender: 'Género',
        email: 'E-mail',
        phone: 'Telefone',
        birthDate: 'Data de nascimento',
        nationality: 'Nacionalidade',
        maritalStatus: 'Estado civil',
        addressLine1: 'Morada',
        addressLine2: 'Complemento de morada',
        postalCode: 'Código postal',
        city: 'Localidade',
        country: 'País',
        workCountry: 'Local de trabalho (país)',
        primaryLocale: 'Idioma',
        status: 'Estado',
        primaryOrgUnitExternalId: 'Departamento / unidade',
        primaryOrgUnitCode: 'Departamento / unidade (Código)',
        supervisorExternalId: 'Responsável funcional',
      },
      employmentContract: {
        externalId: 'ID externo',
        personExternalId: 'Pessoa',
        contractReference: 'Número de contrato',
        status: 'Estado do contrato',
        startDate: 'Data de início',
        endDate: 'Data de fim',
        probationEndDate: 'Fim do período experimental',
        contractType: 'Tipo de contrato',
        position: 'Cargo / função',
        primaryOrgUnitExternalId: 'Departamento / unidade',
        supervisorExternalId: 'Responsável hierárquico',
        workTimeArrangement: 'Regime de horário',
        weeklyHours: 'Horas semanais',
        vacationDaysPerYear: 'Férias (dias/ano)',
        collectiveAgreementCode: 'Convenção coletiva',
      },
    },
  },
  // ── Tenant administration (#432): the five pages that used to be their own
  //     app. Merged verbatim from its catalogue, so the strings are unchanged.
  audit: {
    title: 'Audit Log', subtitle: 'Who did what in your workspace.',
    noAccess: 'No access', noAccessHint: 'You need the audit log permission to view this page.',
    empty: 'No audit events yet', emptyHint: 'Actions in your workspace will appear here.',
    loading: 'Loading…', loadMore: 'Load more',
    filters: { from: 'From', to: 'To', action: 'Action', category: 'Category', actor: 'Actor', outcome: 'Outcome', search: 'Search', searchHint: 'Subject or actor…', apply: 'Apply', reset: 'Reset', all: 'All', actorType: 'Tipo de ator' },
    columns: { time: 'Time', actor: 'Actor', action: 'Action', subject: 'Subject', outcome: 'Outcome' },
    outcome: { success: 'Success', denied: 'Denied', failure: 'Failure' },
    actorType: { user: 'User', system_admin: 'System Admin', support: 'Support', service: 'Service', system: 'System' },
    categories: { auth: 'Auth', access: 'Access', data: 'Data', admin: 'Admin', lifecycle: 'Lifecycle', export: 'Export', security: 'Security' },
    export: { csv: 'Export CSV', ndjson: 'Export NDJSON' },
    detail: { roles: 'Funções', action: 'Action', actorId: 'Actor ID', onBehalfOf: 'On behalf of', ip: 'IP address', source: 'Source', correlationId: 'Correlation ID', changes: 'Changes', before: 'Before', after: 'After', details: 'Details' },
    actions: { login: { succeeded: 'Login succeeded', failed: 'Login failed', attempts_flagged: 'Tentativas de início de sessão falhadas repetidas', locked: 'Conta bloqueada' }, sso: { login_succeeded: 'SSO login succeeded', connection_changed: 'SSO connection changed' }, password: { reset_requested: 'Password reset requested', reset_completed: 'Password reset completed' }, refresh_token: { revoked: 'Session revoked' }, user: { signed_up: 'User signed up', unlocked: 'Conta desbloqueada', disabled: 'Conta desativada', enabled: 'Conta ativada', closed: 'Conta encerrada' }, passkey: { revoked: 'Chaves de acesso removidas por um administrador' }, role: { changed: 'Role changed' }, module_access: { changed: 'Module access changed' }, access: { ownership_transferred: 'Propriedade transferida', member_removed: 'Membro removido', suite_roles_changed: 'Funções Suite alteradas' }, tenant: { created: 'Tenant criado', lifecycle: 'Tenant lifecycle change', exported: 'Tenant exportado' }, module: { activated: 'Module activated', deactivated: 'Module deactivated' }, plan: { changed: 'Plan changed' }, tenant_ai_settings: { changed: 'Definições de IA alteradas' }, tenant_role_editing: { changed: 'Edição de funções alterada' }, settings: { changed: 'Settings changed' }, test_data: { seeded: 'Test data seeded', reset: 'Test data reset' }, onboarding: { setup_chosen: 'Configuração escolhida', demo_started: 'Modo de demonstração iniciado', demo_seeded: 'Dados de demonstração criados', demo_seed_failed: 'Falha ao criar os dados de demonstração', demo_wipe_started: 'Remoção da demonstração iniciada', demo_wiped: 'Dados de demonstração removidos', demo_wipe_failed: 'Falha ao remover os dados de demonstração', setup_finished: 'Configuração concluída', demo_denied: 'Modo de demonstração recusado', module_topup: 'Dados de demonstração adicionados para o novo módulo', demo_reset_started: 'Reposição da demonstração iniciada', demo_tier_switch_started: 'Mudança para a demonstração completa iniciada', demo_rebuilt: 'Demonstração reconstruída' }, company_profile: { created: 'Perfil da empresa criado', updated: 'Perfil da empresa atualizado' }, org_scenario: { activated: 'Cenário organizacional ativado' }, people_data: { wiped: 'Dados de pessoal removidos' }, ats_data: { wiped: 'Dados de recrutamento removidos' }, time_data: { wiped: 'Dados de registo de tempo removidos' }, apprentice_data: { wiped: 'Dados de formação removidos' }, audit_log: { exported: 'Audit log exported' }, billing_charge: { paid: 'Pagamento cobrado', failed: 'Pagamento falhou', refunded: 'Pagamento reembolsado', chargeback: 'Estorno recebido' }, invoice: { issued: 'Fatura emitida' }, mandate: { created: 'Cartão adicionado', replaced: 'Cartão substituído' }, promo_code: { redeemed: 'Código promocional resgatado' }, billing_account: { converted: 'Avaliação convertida em assinatura', delinquent: 'Conta inadimplente', purged: 'Dados de faturação eliminados' }, dunning_case: { opened: 'Recuperação de pagamento iniciada' }, enforcement: { opened: 'Aplicação iniciada', advanced: 'Aplicação escalada', cleared: 'Aplicação levantada' }, billing_exempt: { changed: 'Isenção de faturação alterada' }, billing_data: { wiped: 'Dados de faturação apagados', generated: 'Dados de faturação de teste gerados' }, checkout: { completed: 'Compra concluída', denied: 'Compra recusada' }, job: { created: 'Vaga criada', updated: 'Vaga atualizada', submitted: 'Vaga submetida', archived: 'Vaga arquivada', deleted: 'Vaga eliminada' }, application: { created: 'Candidatura recebida', updated: 'Candidatura atualizada', transitioned: 'Estado da candidatura alterado', withdrawn: 'Candidatura retirada', transferred: 'Candidatura transferida para outra vaga', transfer_declined: 'Transferência de candidatura recusada', rejected: 'Candidatura rejeitada', deleted: 'Candidatura eliminada', emailed: 'E-mail de candidatura enviado' }, interview: { proposed: 'Entrevista proposta', confirmed: 'Entrevista confirmada', cancelled: 'Entrevista cancelada' }, candidate: { anonymized: 'Candidato anonimizado', emailed: 'E-mail ao candidato enviado', identity_changed: 'Dados do candidato alterados', identity_split: 'Candidato separado para um registo próprio', identity_merged: 'Candidatura movida para o candidato com este endereço' }, candidate_dossier: { accessed: 'O candidato consultou os seus dados' }, workflow: { deleted: 'Workflow eliminado', definition: { published: 'Workflow publicado' } }, task: { blocking_overridden: 'Tarefa bloqueadora ignorada', auto_cancelled: 'Tarefa cancelada automaticamente' }, support_access: { requested: 'Acesso de suporte pedido', approved: 'Acesso de suporte aprovado', denied: 'Acesso de suporte recusado', revoked: 'Acesso de suporte terminado', expired: 'Acesso de suporte expirado', request_expired: 'Pedido de acesso de suporte expirado' }, ai_action: { executed: 'Ação de IA executada' }, assistant_run: { proposed: 'A lumi propôs uma ação', approved: 'Ação da lumi aprovada', refused: 'Ação da lumi recusada', failed: 'Ação da lumi falhou' }, assistant_turn: { fanned_out: 'Pedido da lumi abrangeu vários módulos' }, payroll_export_run: { created: 'Exportação de salários iniciada', completed: 'Exportação de salários concluída', failed: 'Exportação de salários falhou', downloaded: 'Exportação de salários transferida' }, payroll_period: { closed: 'Mês de processamento fechado', reopened: 'Mês de processamento reaberto' }, payroll_connection: { updated: 'Ligação de salários alterada' }, payroll_master_data: { exported: 'Dados mestres de salários exportados' }, wage_type: { created: 'Rubrica salarial criada', updated: 'Rubrica salarial atualizada', deleted: 'Rubrica salarial eliminada', starter_catalog_applied: 'Rubricas salariais padrão adicionadas' }, wage_assignment: { created: 'Componente salarial adicionada', updated: 'Componente salarial alterada', deleted: 'Componente salarial removida' }, one_time_payment: { created: 'Pagamento único adicionado', updated: 'Pagamento único alterado', deleted: 'Pagamento único removido' }, payslip: { filed: 'Recibos de vencimento arquivados' } },
  },
  sso: {
    title: 'Single Sign-On',
    subtitle: 'Ligar o fornecedor de identidade (OIDC) para que a equipa inicie sessão através dele.',
    issuerUrl: 'URL do emissor (descoberta OIDC)',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    clientSecretKeep: 'Deixar vazio para manter o segredo guardado',
    label: 'Nome a apresentar',
    allowedDomains: 'Domínios de e-mail permitidos (separados por vírgulas)',
    jitEnabled: 'Criar utilizadores automaticamente no primeiro início de sessão (JIT)',
    jitDefaults: 'Acesso predefinido aos módulos para novos utilizadores',
    jitModulePlaceholder: 'Escolher um módulo',
    jitRoles: 'Funções',
    jitCatalogUnreadable: 'Não foi possível ler as funções deste módulo. As funções guardadas mantêm-se inalteradas.',
    jitUnknownRole: '{key} (desconhecida)',
    addJit: 'Adicionar módulo',
    remove: 'Remove',
    redirectUri: 'URI de redirecionamento (registar no IdP)',
    copy: 'Copiar',
    test: 'Testar ligação',
    testOk: 'Descoberta bem-sucedida.',
    testFailed: 'Teste falhou',
    save: 'Guardar',
    saved: 'Guardado.',
    delete: 'Remover ligação',
    deleteConfirm: 'Remover mesmo esta ligação SSO?',
    enforce: 'Exigir início de sessão apenas via SSO',
    enforceHint: 'O início de sessão com palavra-passe está desativado para todos, exceto os administradores do sistema e o proprietário do workspace.',
    noConnection: 'Ainda não há nenhuma ligação SSO configurada.',
    deleted: 'Ligação removida.',
    enforceEnabled: 'O início de sessão passa a ser feito apenas via SSO.',
    enforceDisabled: 'O início de sessão com palavra-passe está novamente disponível.',
    jitNeedsVerifiedDomain: 'Os utilizadores só são criados automaticamente para endereços de um domínio verificado.',
    domainsTitle: 'Domínios de e-mail',
    domainsIntro: 'Um domínio só conta para o início de sessão SSO depois de provar que é vosso: publique este registo TXT no DNS do domínio e depois verifique-o. Entretanto, as contas já associadas continuam a iniciar sessão.',
    domainStatus: { pending: 'Não verificado', verified: 'Verificado', legacy: 'Verificar em breve' },
    domainLegacyUntil: 'Verificar até {date}',
    domainRecordName: 'Nome do registo (TXT)',
    domainRecordValue: 'Valor do registo',
    domainVerify: 'Verificar registo',
    domainVerified: '{domain} está verificado.',
    domainError: { record_not_found: 'Ainda não existe nenhum registo TXT com este nome. As alterações de DNS podem demorar algum tempo.', value_mismatch: 'Existe um registo TXT, mas o valor não corresponde. Copie o valor exatamente.', dns_error: 'A consulta DNS falhou. Tente novamente dentro de alguns minutos.' },
  },  users: { seatLimit: { bookMore: 'Todos os {booked} lugares de utilizador reservados estão ocupados. Reserve pelo menos {required} lugares de utilizador para convidar outra pessoa.', leaveFreelancer: 'Este workspace está em modo freelancer: uma pessoa, um lugar. Sair do modo freelancer reserva {required} lugares de utilizador e abre espaço para as pessoas que convidar.', notified: 'Todos os {booked} lugares de utilizador reservados estão ocupados. O proprietário do workspace e os Billing Managers podem reservar mais lugares.', cta: 'Reservar mais lugares' }, removeSuccess: '{email} foi removido deste workspace.', saveSuccess: 'Alterações de acesso guardadas para {email}.', saveFailedFor: 'Não foi possível guardar {targets} para {email}: {reason}', saveFailedOthersSaved: 'As restantes alterações foram guardadas.', suiteRolesTarget: 'as funções de suite', unsaved: 'Por guardar', defaultRoleHint: 'Função predefinida para convites internos', refreshFailed: 'Não foi possível atualizar a lista de membros. Recarregue a página para ver o estado guardado.', title: 'Utilizadores & Atribuições', email: 'E-mail', suite: 'Suite', suiteSuiteAdmin: 'Admin', suiteSuiteAdminHint: 'Admin do workspace: gere membros, acesso aos módulos, SSO e segurança.', suiteBillingManager: 'Billing Manager', suiteBillingManagerHint: 'Pode gerir a faturação (faturas, cartão, plano).', suiteSupportAgent: 'Support Agent', suiteSupportAgentHint: 'Trata os tickets de suporte (responder, escalar, fechar).', suiteDataProtection: 'Encarregado de proteção de dados', suiteDataProtectionHint: 'Analisa e aprova os pedidos dos titulares dos dados e os apagamentos e pode consultar os dados dos membros em cada módulo ativo.', suiteOwnerLocked: 'O proprietário do workspace é sempre Admin.', saveFailed: 'Não foi possível guardar a atribuição', inviteSuccess: '{email} foi convidado com sucesso', invite: { titleInternal: 'Convidar um membro', titleExternal: 'Convidar externamente', hintInternal: 'Recebe automaticamente a função predefinida em Tempo e Pessoal — é possível adicionar mais funções logo após o convite.', hintExternal: 'Sem funções predefinidas: sem uma função, esta pessoa não pode abrir nenhum módulo. Configure o acesso logo após o convite.', submit: 'Convidar', sentTitle: 'Convite enviado', sentLead: '{email} foi convidado(a) e aparece como Convidado.', sentBodyInternal: 'Já tem a função predefinida em Tempo e Pessoal.', sentBodyExternal: 'Ainda sem funções — configure a que esta pessoa pode aceder.', revoke: 'Retirar convite', moreRoles: 'Mais funções', setupRoles: 'Configurar funções', done: 'Concluído', revokedTitle: 'Convite retirado', revokedBody: '{email} foi removido(a) do workspace. O link de convite deixou de ser válido.' }, removeUser: 'Remover', confirmRemove: 'Remover {email} deste tenant? Todas as atribuições de módulos serão eliminadas.', statusActive: 'Ativo', statusInvited: 'Convidado', statusDisabled: 'Desativado', transferOwnership: 'Transferir a propriedade', transferTitle: 'Transferir a propriedade do workspace', transferIntro: '{from} entrega este workspace a {to}. Existe apenas um proprietário: ao confirmar, {from} deixa de o ser.', transferConsequences: 'O que muda:', transferConsequenceBreakGlass: 'O acesso de emergência quando o SSO está indisponível passa para {to}: se o fornecedor de identidade estiver inacessível, {to} continua a poder entrar com palavra-passe, {from} já não.', transferConsequenceOutgoing: '{from} mantém todas as funções que já tem, incluindo Admin — apenas a propriedade muda. Pode ser desativado ou removido como qualquer outro membro.', transferConsequenceSuiteAdmin: '{to} recebe a função Admin, caso ainda não a tenha. Ninguém perde funções.', transferSsoWarning: '{email} inicia sessão através de SSO e não tem palavra-passe. Se o SSO estiver indisponível, o acesso de emergência herdado não pode ser usado; é possível definir uma palavra-passe a qualquer momento em «Esqueci-me da palavra-passe».', transferBlockedPending: '{email} ainda não aceitou o convite. Isso tem de acontecer antes da transferência.', transferBlockedDisabled: 'A conta de {email} está desativada. É necessário reativá-la antes de transferir a propriedade.', transferConfirmFieldLabel: 'Confirmar o novo proprietário', transferConfirmHint: 'Escrever {email} para ativar o botão.', transferSuccess: '{email} passou a ser o proprietário deste workspace.', transferFailed: 'Não foi possível transferir a propriedade. Tentar novamente.', transferErrorForbidden: 'Só o proprietário atual pode transferir a propriedade.', transferErrorNotMember: '{email} já não é membro deste workspace.', transferErrorAlreadyOwner: '{email} já é o proprietário deste workspace.', transferErrorRaced: 'A propriedade mudou durante esta transferência. Recarregue a lista e tente novamente.', transferErrorIneligible: '{email} não pode assumir a propriedade neste momento. Atualizar a lista para ver o estado atual.', resendInvite: 'Reenviar convite', disable: 'Desativar', enable: 'Ativar', confirmDisable: 'Desativar {email}? A sessão será terminada de imediato e não será possível iniciar sessão até reativar a conta.', resendSuccess: 'Convite reenviado para {email}.', resendEmailFailed: 'Não foi possível enviar o e-mail de convite para {email}. Tente novamente.', disableSuccess: '{email} foi desativado.', enableSuccess: '{email} foi ativado.', inviteEmailFailed: '{email} foi adicionado, mas não foi possível enviar o e-mail de convite. Pode reenviá-lo.', searchPlaceholder: 'Pesquisar por e-mail', rolesFilterPlaceholder: 'Filtrar por função', clearRolesFilter: 'Repor filtro', memberCount: '{count} membros', memberCountFiltered: '{shown} de {count} membros', inviteInternal: 'Convidar', inviteExternal: 'Convidar externamente', removeRoleFilter: 'Remover função do filtro', columns: { account: 'Conta', status: 'Estado', roles: 'Funções' },moduleNames: { ats: 'Recrutamento', time_tracking: 'Tempo', people: 'Pessoal', apprenticeship: 'Ausbildung' }, accessDenied: 'Acesso negado', moreActions: 'Mais ações para {email}', noSearchResults: 'Nenhum membro corresponde a «{query}».', editSubtitle: 'Editar funções e acesso', suiteConfirmGrantTitle: 'Atribuir uma função de suite?', suiteConfirmRevokeTitle: 'Remover uma função de suite?', suiteConfirmMixedTitle: 'Alterar funções de suite?', suiteConfirmLead: 'Isto muda para {email}:', suiteConfirmRemoved: 'Perde {role}.', suiteConfirmAccept: 'Sim, guardar' },
  // The consent page of an agent connection (ADR 0103 rule 10, PDR 0035).
  connectAgent: {
    title: 'Ligar um agente de IA',
    heading: 'Um agente de IA quer agir em seu nome',
    intro: 'Um cliente de IA que se apresenta como “{client}” pede para trabalhar no lumi em seu nome, no espaço de trabalho {workspace}.',
    fields: {
      client: 'Apresenta-se como',
      redirectHost: 'Envia-o de volta para',
      website: 'Site indicado',
      workspace: 'No espaço de trabalho',
    },
    scopesHeading: 'Pede para:',
    scope: {
      read: 'Ler o que pode ver no lumi',
      act: 'Propor e executar ações em seu nome — cada ação precisa da sua confirmação',
      ask: 'Fazer perguntas ao lumi',
    },
    meaning: {
      heading: 'O que significa “Permitir”',
      asYou: 'Age em seu nome, exatamente com as suas permissões neste espaço de trabalho — nunca com mais.',
      egress: 'Tudo o que ler no lumi vai para o fornecedor por trás de “{client}”, fora do lumi.',
      revocable: 'Pode terminar a ligação a qualquer momento na página da sua conta.',
    },
    standing: {
      label: 'Executar ações nos meus próprios registos sem perguntar sempre',
      hint: 'Nunca abrange registos de outras pessoas nem decisões desfavoráveis — nesses casos pergunta sempre. Pode alterar isto a qualquer momento na página da sua conta.',
    },
    rolePins: {
      title: 'Função por módulo',
      hint: 'Onde tem mais do que uma função, escolha aquela em que o agente trabalha. Nunca pode fazer mais do que essa função permite.',
      default: 'Predefinição do módulo ({rule})',
      defaultRule: {
        first_assigned: 'a sua primeira função atribuída',
        first_by_key: 'a sua primeira função pela chave',
        all_roles: 'todas as suas funções em conjunto',
      },
      modules: {
        ats: 'Recrutamento',
        time: 'Tempo',
        people: 'Pessoal',
      },
      notHeld: 'Já não tem a função escolhida nesse módulo. Escolha novamente.',
    },
    disabled: {
      title: 'Os agentes de IA externos estão desativados neste espaço de trabalho',
      body: 'Um proprietário ou administrador pode ativá-los em Administração → Agentes de IA externos. Até lá, só pode recusar este pedido.',
    },
    actions: {
      allow: 'Permitir',
      deny: 'Recusar',
    },
    returning: 'A regressar a {client}…',
    invalid: {
      title: 'Este pedido de início de sessão já não é válido',
      hint: 'Inicie novamente a ligação a partir do seu cliente de IA.',
    },
  },
  // Administration › External AI agents (ADR 0103 rule 12, PDR 0035 rule 2).
  externalAgents: {
    title: 'Agentes de IA externos',
    cardTitle: 'Agentes de IA externos',
    noAccess: 'Sem acesso',
    noAccessHint: 'Só o proprietário do espaço de trabalho e os administradores da suite podem alterar esta definição.',
    intro: 'Com isto ativado, os membros podem ligar o seu próprio cliente de IA — Claude Code, OpenClaw, … — e deixá-lo agir em seu nome neste espaço de trabalho.',
    points: {
      asMember: 'Um agente trabalha exatamente com as permissões do membro que o ligou — nunca com mais.',
      confirmed: 'Esse membro confirma cada ação que o agente propõe antes de ela acontecer.',
      adverse: 'As decisões desfavoráveis sobre outras pessoas precisam sempre do painel do lumi; um agente nunca as pode confirmar.',
    },
    egress: {
      title: 'Para onde vão os dados dos membros',
      body: 'Tudo o que um agente lê vai para o cliente de IA que o membro liga — um destinatário fora da cadeia de subcontratantes do lumi, escolhido pelo seu espaço de trabalho e pelo membro.',
      worksCouncil: 'Se os membros podem usar estes clientes é uma decisão sua enquanto entidade empregadora — considere envolver a comissão de trabalhadores.',
    },
    switchLabel: 'Permitir que os membros liguem agentes de IA externos',
    saving: 'A guardar…',
    activeConnections: 'Nenhuma ligação ativa. | 1 ligação ativa. | {n} ligações ativas.',
    offHint: 'Desativar termina de imediato todas as ligações neste espaço de trabalho.',
    roleNote: 'Só o proprietário do espaço de trabalho ou um administrador da suite pode alterar isto.',
    savedOn: 'Os agentes de IA externos estão ativados. Os membros já podem ligar o seu cliente de IA.',
    savedOff: 'Os agentes de IA externos estão desativados. | Os agentes de IA externos estão desativados. Terminou 1 ligação. | Os agentes de IA externos estão desativados. Terminaram {n} ligações.',
    disableConfirm: {
      title: 'Desativar os agentes de IA externos?',
      body: 'De momento não há nenhuma ligação ativa; os membros deixarão de se poder ligar. | Isto termina de imediato 1 ligação. | Isto termina de imediato {n} ligações.',
      confirm: 'Desativar',
    },
  },
  supportAccess: {
    revokeConfirm: 'O acesso do suporte termina de imediato. A equipa de suporte perde o acesso a este espaço de trabalho.',
    title: 'Acesso de suporte',
    subtitle: 'Acesso temporário ao seu espaço para a nossa equipa de suporte, autorizado por si.',
    noAccess: 'Sem acesso',
    noAccessHint: 'Apenas o proprietário do espaço e os administradores da suite podem analisar estes pedidos.',
    empty: 'Nenhum acesso de suporte pedido',
    emptyHint: 'Quando o nosso suporte precisar de aceder ao seu espaço para tratar um pedido, este aparece aqui.',
    pendingTitle: 'Pedido de acesso pendente',
    pendingIntro: '{supporter} pede {days} dias de acesso a este espaço.',
    activeTitle: 'O acesso de suporte está ativo',
    activeIntro: '{supporter} pode atualmente trabalhar neste espaço.',
    historyTitle: 'Histórico',
    revokeHint: 'Terminar o acesso produz efeito dentro de um minuto.',
    expiringNow: 'A expirar agora',
    remainingDays: 'faltam {days} d {hours} h',
    remainingHours: 'faltam {hours} h {minutes} min',
    remainingMinutes: 'faltam {minutes} min',
    fields: {
      requestedAt: 'Pedido em',
      ticket: 'Pedido de suporte',
      duration: 'Duração',
      durationValue: '{days} dias',
      reason: 'Motivo indicado',
      approvedBy: 'Aprovado por',
      expiresAt: 'Expira',
      remaining: 'Tempo restante',
      grantedModules: 'Funções concedidas',
    },
    consent: { allRoles: 'A pessoa do suporte pode mudar para qualquer função que estes módulos ofereçam — vê o que os seus colaboradores veem, não apenas a vista de administração.', modulesHeading: 'Este acesso abrange:', via: 'através de {module}',
      heading: 'O que está a aprovar',
      data: 'O suporte poderá aceder aos dados deste espaço em todos os módulos ativos, incluindo dados pessoais de colaboradores e candidatos.',
      audited: 'Cada ação fica registada no seu registo de auditoria e marcada como ação de suporte.',
      duration: 'O acesso termina automaticamente ao fim de {days} dias.',
      revocable: 'Pode terminá-lo a qualquer momento; produz efeito dentro de um minuto.',
    },
    actions: { approve: 'Aprovar o acesso', deny: 'Recusar', revoke: 'Terminar agora' },
    status: {
      requested: 'Pendente',
      active: 'Ativo',
      denied: 'Recusado',
      revoked: 'Terminado',
      expired: 'Expirado',
      request_expired: 'Pedido expirado',
    },
    columns: { supporter: 'Conta de suporte', requestedAt: 'Pedido em', status: 'Estado', endedAt: 'Terminado' },
    success: { approved: 'Acesso do suporte aprovado.', denied: 'Pedido recusado.', revoked: 'Acesso do suporte terminado.' },
    errors: {
      consentChanged: 'O texto de consentimento mudou. Leia-o novamente antes de aprovar.',
      selfApproval: 'A conta requerente não pode aprovar o seu próprio pedido.',
    },
  },
  // Administration › Statutory rules (ADR 0091): the statutory rule catalogue
  // and the workspace's agreements and deviations, moved here from Time's
  // settings with the page.
  statutory: {
    title: 'Regras legais e acordos',
    intro: 'As regras legais aplicam-se automaticamente e são mantidas atualizadas de forma centralizada. Aqui indicas apenas onde a tua empresa se desvia delas – cada desvio precisa de uma base, por exemplo uma convenção coletiva ou um acordo de empresa.',
    disclaimer: 'Valores de orientação segundo a lei – não é aconselhamento jurídico. As convenções coletivas podem ser mais rigorosas.',
    // "Checked, fits us" (issue 713): the one-time confirmation of the statutory defaults.
    confirmation: {
      unchecked: {
        title: 'Ainda não verificado',
        // The short sentence for someone who may read the page but not confirm (a support grant): no picker, no button.
        body: 'O lumi começa com as regras legais predefinidas. Se se adequarem à empresa, confirme-o. Se se aplicar uma convenção coletiva ou um acordo de empresa, crie abaixo um desvio.',
        confirm: 'Verificado, serve para nós',
        // The mode picker (issue 780) is shown to someone who can confirm; the tile titles are the settings card's own (statutory.workspace.modeFlexible/modeStrict).
        lead: 'O lumi começa com as regras legais predefinidas – tempo máximo de trabalho, pausas, descanso. Decida o que acontece quando um registo viola uma delas e confirme depois que as regras se adequam à empresa.',
        standard: 'Predefinição',
        later: 'Pode alterar ambas as coisas mais tarde, a qualquer momento.',
        agreements: 'Aplica-se na empresa uma convenção coletiva ou um acordo de empresa segundo o qual uma regra é diferente ou não se aplica? Então crie abaixo um {basis} – os avisos seguem-no. Não existe um modo sem avisos.',
        agreementsBasis: 'desvio com o seu fundamento',
        flexible: {
          personLabel: 'A pessoa', personText: 'vê ao guardar que regra foi violada e por quanto – o registo mantém-se.',
          managerLabel: 'A chefia', managerText: 'vê as violações da semana na aprovação e decide em conjunto com a pessoa.',
          recordLabel: 'O histórico', recordText: 'guarda cada violação – a favor da empresa, não contra ela.',
        },
        strict: {
          personLabel: 'A pessoa', personText: 'não pode guardar um registo que viole uma regra imposta – e vê porquê. Uma pausa em falta é guardada e apresentada.',
          managerLabel: 'A chefia', managerText: 'vê na aprovação apenas o que mesmo assim surge: pausas em falta e encerramentos automáticos.',
          fitLabel: 'Serve se', fitText: 'as exceções não puderem existir na empresa – por exemplo com menores.',
        },
      },
      // After a save that is not a review, while unconfirmed (issue 990): the next step, in place.
      afterSave: { body: 'Guardado. Isto ainda não confirma as regras de tempo de trabalho – confirma agora que se adequam a vocês.', confirm: 'Confirmar agora' },
      confirmed: { title: 'Verificado', body: 'Confirmado em {date} por {name}: as regras legais servem para nós.', bodyNoName: 'Confirmado em {date}: as regras legais servem para nós.' },
      ownDeviation: { title: 'Verificado', body: 'O workspace tem desvios próprios, por isso as regras já foram analisadas.' },
      error: 'Não foi possível guardar a confirmação. Tente novamente.',
    },
    noJurisdictions: 'Ainda não está definida nenhuma jurisdição: não há pessoas com local de trabalho nem jurisdição predefinida. Escolhe uma abaixo e as regras legais aparecem aqui.',
    jurisdictionEu: 'Diretiva da UE',
    jurisdictionDefault: '{name} (predefinida)',
    // Who the number is (issue 990): active employees in Time judged by this law —
    // on a tab that is not the default, only those whose work location is there;
    // on the default's tab, also everyone who falls back to it.
    headcountLine: 'Jurisdição {country}: estas regras não se aplicam agora a ninguém. | Jurisdição {country}: estas regras avaliam o tempo de trabalho de 1 pessoa em Tempo que trabalha aqui. | Jurisdição {country}: estas regras avaliam o tempo de trabalho de {count} pessoas – todos os colaboradores ativos em Tempo que trabalham aqui.',
    headcountLineDefault: 'Jurisdição {country}: estas regras não se aplicam agora a ninguém. | Jurisdição {country}: estas regras avaliam o tempo de trabalho de 1 pessoa em Tempo que trabalha aqui ou está abrangida pela jurisdição predefinida. | Jurisdição {country}: estas regras avaliam o tempo de trabalho de {count} pessoas – todos os colaboradores ativos em Tempo que trabalham aqui ou estão abrangidos pela jurisdição predefinida.',
    fallbackLine: 'Pessoas sem local de trabalho, ou com um local que o catálogo não cobre: {count} – aplica-se-lhes {country}.',
    createModels: 'Criar os modelos de horário de trabalho deste país',
    domains: {
      workingTime: 'Tempo de trabalho',
      pay: 'Janelas horárias de acréscimo',
      overtime: 'Trabalho suplementar',
      leave: 'Férias',
    },
    rules: {
      maxDailyHours: 'Tempo máximo de trabalho diário',
      maxWeeklyHours: 'Tempo máximo de trabalho semanal',
      breaks: 'Pausas',
      minDailyRest: 'Descanso diário',
      nightWorkBan: 'Proibição de trabalho noturno',
      minWeeklyRest: 'Descanso semanal',
      avgWeeklyHours: 'Tempo de trabalho semanal médio',
      normalDailyHours: 'Período normal de trabalho diário',
      normalWeeklyHours: 'Período normal de trabalho semanal',
      nightWindow: 'Período noturno para acréscimos',
      nightCoreWindow: 'Núcleo do período noturno para acréscimos superiores',
      overtimeThreshold: 'Trabalho suplementar a partir de (horas semanais)',
      overtimeSurcharge: 'Acréscimos por trabalho suplementar',
      minLeaveDays: 'Férias anuais mínimas',
    },
    kinds: {
      collectiveAgreement: 'Convenção coletiva',
      worksAgreement: 'Acordo de empresa',
      authorityPermit: 'Autorização da autoridade',
      companyPolicy: 'Regra interna',
    },
    value: {
      hoursUnit: 'h',
      days: '{days} dias',
      breakStage: '{minutes} min acima de {hours} h',
      weeklyAverage: '{hours} h em média ao longo de {weeks} semanas',
      nightWorkBan: 'sem trabalho entre as {start} e as {end}',
      tierFirst: '{percent} % desde a primeira hora suplementar',
      tierAfter: '{percent} % após {hours} horas suplementares',
      none: 'Nenhuma regra',
      switchedOff: 'A regra não se aplica (desativada)',
    },
    status: {
      statutory: 'Segundo a lei',
      noStatutoryRule: 'Sem regra legal',
      infoOnly: 'Apenas informativo',
      deviation: 'Desvio',
      deviationStricter: 'Desvio · mais rigoroso',
      deviationLooser: 'Desvio · menos rigoroso',
      deviationMoreFavourable: 'Desvio · mais favorável do que a lei',
      deviationLessFavourable: 'Desvio · menos favorável do que a lei',
      deviationEqual: 'Desvio · igual à lei',
      deviationMixed: 'Desvio · em parte mais rigoroso, em parte menos',
      deviationMixedFavourable: 'Desvio · em parte mais favorável, em parte menos',
    },
    hint: {
      stricter: 'Mais rigoroso do que a lei – permitido com qualquer base.',
      looser: 'Menos rigoroso do que a lei – precisa de uma convenção coletiva, um acordo de empresa ou uma autorização da autoridade como base.',
      moreFavourable: 'Mais favorável do que a lei – permitido com qualquer base.',
      lessFavourable: 'Menos favorável do que a lei – precisa de uma convenção coletiva, um acordo de empresa ou uma autorização da autoridade como base.',
      mixed: 'Em parte mais rigoroso, em parte menos rigoroso do que a lei – precisa de uma convenção coletiva, um acordo de empresa ou uma autorização da autoridade como base.',
      mixedFavourable: 'Em parte mais favorável, em parte menos favorável do que a lei – precisa de uma convenção coletiva, um acordo de empresa ou uma autorização da autoridade como base.',
      equal: 'Igual ao valor legal – não é necessário um desvio.',
      incomparable: 'Nesta regra não existe «mais rigoroso» nem «menos rigoroso» – qualquer base serve.',
      blocked: 'Uma regra interna não pode ficar aquém da lei. Escolhe como base uma convenção coletiva, um acordo de empresa ou uma autorização da autoridade – ou um valor que pelo menos iguale a lei.',
    },
    table: {
      rule: 'Regra',
      applies: 'Aplica-se',
      note: 'Nota sobre o enquadramento legal',
      deviate: 'Definir desvio',
      backToStatute: 'Voltar à lei',
      statutoryWouldBe: 'Por lei seria: {value}',
      statutoryWouldBeNone: 'A lei não prevê aqui nenhuma regra.',
      basis: 'Base: {name}',
      basisWithClause: 'Base: {name}, {clause}',
      coveredDeviation: 'Com o código de convenção {code}: {value} ({name})',
      futureDeviation: 'A partir de {date}: {value} ({name})',
      fallbackApplies: 'A lei não fixa aqui nenhum período – aplica-se este até que um acordo fixe outro.',
      fallbackWouldBe: 'A lei não fixa aqui nenhum período – sem o desvio seria: {value}',
      editDeviationOf: 'Editar o desvio de «{name}»',
      backToStatuteOf: 'Repor a lei no lugar do desvio de «{name}»',
    },
    notice: {
      fallback: 'O catálogo de regras legais está temporariamente indisponível. É apresentada a base incluída; alterações recentes podem faltar.',
      unjudged: 'Pessoas a quem não se aplica atualmente nenhuma regra legal: {count}. Não têm local de trabalho e não está definida uma jurisdição predefinida – escolhe uma abaixo.',
      upcoming: 'A partir de {date}, a regra legal «{rule}» passa a: {value}.',
      upcomingNone: 'A partir de {date}, a regra legal «{rule}» deixa de se aplicar.',
      upcomingDeviationStays: 'O teu desvio mantém-se.',
      reviewTitle: 'A rever: {rule}',
      review: 'O valor legal mudou desde que este desvio foi definido ({agreement}). A lei prevê agora: {statutory}. O teu desvio: {deviation}.',
      keepDeviation: 'Manter o desvio',
    },
    minors: {
      title: 'Jovens com menos de 18 anos',
      headcount: 'Pessoas: {count}',
      headcountNone: 'nenhuma de momento',
      hint: 'Às pessoas com menos de 18 anos aplicam-se estas regras legais de proteção de menores em vez das gerais – automaticamente, com base na data de nascimento registada no Pessoal. Os acordos não se desviam delas.',
      generalApplies: 'Ainda sem regra própria – até lá aplica-se a geral.',
      upcoming: 'A partir de {date}: {value}',
      upcomingNone: 'A partir de {date}, esta regra de proteção de menores deixa de se aplicar.',
    },
    form: {
      value: 'Valor do desvio',
      daysUnit: 'dias',
      stageAfterHours: 'Tempo de trabalho superior a (h)',
      stageMinutes: 'Pausa no total (min)',
      tierAfterHours: 'A partir de horas suplementares por semana (h)',
      tierPercent: 'Acréscimo (%)',
      addStep: 'Adicionar escalão',
      removeStep: 'Remover escalão {row}',
      stageAfterHoursRow: 'Escalão {row}: tempo de trabalho superior a (h)',
      stageMinutesRow: 'Escalão {row}: pausa no total (min)',
      tierAfterHoursRow: 'Escalão {row}: a partir de horas suplementares por semana (h)',
      tierPercentRow: 'Escalão {row}: acréscimo (%)',
      averageHours: 'Horas por semana em média',
      averageWeeks: 'Período de referência (semanas)',
      windowStart: 'Início',
      windowEnd: 'Fim',
      windowHint: 'Se o fim for anterior ao início, a janela prolonga-se para lá da meia-noite.',
      statutoryIs: 'A lei prevê: {value}',
      comparisonBase: 'Sem regra legal aplica-se {value} – o desvio é medido em relação a esse valor.',
      basis: 'Base',
      basisHint: 'O acordo em que o desvio assenta.',
      basisPick: 'Escolher uma base…',
      basisNew: 'Criar uma nova base…',
      basisRequired: 'Escolhe uma base.',
      clause: 'Cláusula',
      clauseHint: 'Onde consta a disposição, p. ex. «art. 4.º, n.º 2». Opcional.',
      invalid: {
        hours: 'Indica as horas: mais de 0 e no máximo 168.',
        days: 'Indica os dias: mais de 0 e no máximo 366.',
        breakLadder: 'Verifica os escalões: de 1 a 6, por ordem crescente de tempo de trabalho (mais de 0 até 24 h), com uma pausa de mais de 0 até 480 min e nunca inferior à do escalão anterior.',
        weeklyAverage: 'Verifica os valores: horas acima de 0 e no máximo 168, período de referência de 1 a 104 semanas.',
        timeWindow: 'Indica uma hora de início e uma de fim; têm de ser diferentes.',
        percentTiers: 'Verifica os escalões: de 1 a 6, o primeiro a partir de 0 horas suplementares, os restantes por ordem crescente; acréscimo entre 0 e 300 %, com no máximo duas casas decimais.',
      },
    },
    agreement: {
      name: 'Nome',
      title: 'Acordos',
      subtitle: 'Convenções coletivas, acordos de empresa, autorizações e regras internas – as bases dos teus desvios.',
      new: 'Novo acordo',
      edit: 'Editar acordo',
      empty: 'Ainda sem acordos – aplicam-se em tudo as regras legais.',
      inactive: 'Atualmente não em vigor',
      migrated: 'Transposto das definições anteriores',
      noDeviations: 'Ainda sem desvios. Define-os acima, na regra correspondente.',
      needsReview: 'A rever',
      kind: 'Tipo de acordo',
      companyPolicyHint: 'Uma regra interna só pode ser mais rigorosa ou mais favorável do que a lei.',
      nameHint: 'Por exemplo, «Convenção coletiva da metalurgia» ou «Acordo de pausas 2026».',
      nameRequired: 'Dá um nome ao acordo.',
      reference: 'Número de referência',
      referenceHint: 'Opcional, p. ex. número de registo ou de despacho.',
      jurisdiction: 'Jurisdição',
      validFrom: 'Válido desde',
      validFromRequired: 'Indica a partir de quando o acordo se aplica.',
      validTo: 'Válido até',
      validToHint: 'Deixa vazio se o acordo não tiver data de fim.',
      validSince: 'válido desde {from}',
      validRange: 'válido de {from} a {to}',
      scope: 'Aplica-se a',
      scopeAll: 'todas as pessoas desta jurisdição',
      scopeCovered: 'apenas pessoas abrangidas pela convenção',
      scopeCoveredCode: 'apenas o código de convenção {code}',
      coverageCode: 'Código de convenção',
      coverageCodeHint: 'O código é definido no contrato de trabalho da pessoa no Pessoal. O acordo aplica-se apenas a pessoas com exatamente este código.',
      deleteTitle: 'Eliminar «{name}»?',
      deleteConfirm: 'Ao eliminar o acordo, eliminam-se também os seus desvios (número: {count}). Essas regras voltam a seguir a lei.',
      deleteConfirmEmpty: 'O acordo não tem desvios; as regras em vigor não mudam.',
      editDeviation: 'Editar desvio: {rule}',
      removeDeviation: 'Voltar à lei: {rule}',
    },
    backConfirm: {
      title: '«{rule}»: voltar à lei?',
      body: 'O desvio será removido. Depois volta a aplicar-se o valor legal: {value}.',
      bodyNone: 'O desvio será removido. A lei não prevê aqui nenhuma regra – depois não se aplica nenhuma.',
      bodyFallback: 'O desvio será removido. A lei não prevê aqui nenhuma regra – depois volta a aplicar-se {value}.',
    },
    workspace: {
      title: 'Definições do workspace',
      defaultJurisdiction: 'Jurisdição predefinida',
      defaultJurisdictionHint: 'Aplica-se a pessoas sem local de trabalho ou com um local que o catálogo não cobre.',
      noDefault: 'Sem predefinição',
      mode: 'Quando um registo viola uma regra',
      modeFlexible: 'Avisar e registar',
      modeFlexibleHint: 'O registo é guardado. A violação é apresentada e fica registada.',
      modeStrict: 'Bloquear o registo',
      modeStrictHint: 'Um registo que viole uma regra imposta não pode ser guardado.',
      originSignup: 'Retirado do país que a tua empresa indicou no registo: {country}.',
      originFallbackPrevious: 'Até que o país indicado pela tua empresa no registo seja conhecido e esteja no catálogo, aplicam-se as regras de {current} – as regras pelas quais este espaço de trabalho era avaliado até agora.',
      originFallbackUnknown: 'O país da tua empresa ainda não é conhecido, por isso aplica-se o mínimo da UE até alguém escolher aqui o país.',
      originFallbackUncovered: 'No registo, a tua empresa indicou {country}. O catálogo ainda não tem regras para esse país, por isso aplica-se o mínimo da UE.',
      originFallbackCovered: 'No registo, a tua empresa indicou {country}, cujas regras já estão no catálogo. Escolhe-o aqui para as aplicar – até lá aplica-se o mínimo da UE.',
    },
    toast: {
      settingsSaved: 'Definições guardadas',
      deviationSaved: 'Desvio guardado',
      deviationConfirmed: 'Desvio confirmado',
      backToStatute: 'Desvio removido – volta a aplicar-se a lei',
      agreementSaved: 'Acordo guardado',
      agreementDeleted: 'Acordo eliminado',
      modelsCreated: 'Modelos de horário de trabalho criados: {count}',
      modelsExist: 'Os modelos de horário de trabalho deste país já existem.',
    },
    errors: {
      rival: '«{name}» já define esta regra para as mesmas pessoas num período sobreposto.',
      validToBeforeFrom: 'O fim da validade não pode ser anterior ao início.',
      coverageCodeRequired: 'Indica o código de convenção a que o acordo se aplica.',
      invalidValue: 'O valor não é válido para esta regra. Verifica-o.',
      jurisdictionUnknown: 'Esta jurisdição não consta do catálogo de regras legais.',
      dateInvalid: 'Indica uma data válida.',
      labelInvalid: 'Verifica os campos de texto: o nome é obrigatório e nenhum campo pode ter mais de 160 caracteres.',
      noModelPresets: 'Não existem modelos de horário de trabalho preparados para este país.',
      kindInvalid: 'Escolhe o tipo de acordo na lista.',
      modeInvalid: 'Escolhe o que acontece quando um registo viola uma regra.',
      ruleUnknown: 'Esta versão da aplicação não conhece esta regra. Recarrega a página.',
      ruleInfoOnly: 'Esta regra é apresentada apenas a título informativo – não é possível desviar-se dela.',
    },
    // The workspace page around the section (Administration › Statutory rules):
    // a workspace without Time, and a viewer time-api does not admit.
    page: {
      timeInactiveTitle: 'O Tempo não está ativo neste espaço de trabalho',
      timeInactive: 'As regras legais aplicam-se ao tempo de trabalho registado no Tempo. Quando o Tempo fizer parte deste espaço de trabalho, é aqui que indicas onde a tua empresa se afasta delas.',
      noAccess: 'Não podes gerir as regras legais deste espaço de trabalho. Podem fazê-lo o proprietário do espaço de trabalho, a administração de suite e os membros do Tempo com permissão para gerir a conformidade.',
    },
  },
  // Administration › Training occupations (ADR 0092).
  trainingOccupations: {
    title: 'Profissões de formação',
    columns: {
      occupation: 'Profissão de formação',
      duration: 'Duração',
      regulation: 'Regulamento de formação',
      apprentices: 'Formandos',
    },
    duration: '{count} meses',
    regulationIssued: 'de {date}',
    regulationValidFrom: 'em vigor desde {date}',
    areas: {
      IH: 'Indústria e comércio (IHK)',
      Hw: 'Ofícios (HWK)',
      oeD: 'Serviço público',
      Lw: 'Agricultura',
      FB: 'Profissões liberais',
      Hausw: 'Economia doméstica',
      See: 'Navegação marítima',
    },
    branches: {
      specialisations: 'Especializações',
      focuses: 'Áreas de aprofundamento',
      any: 'Especializações / áreas de aprofundamento',
    },
    requirements: {
      onWall: 'Posições do regulamento de formação no mural de competências: {count}',
      version: 'regulamento de {date}',
      none: 'As posições do regulamento de formação ainda não estão disponíveis. Aparecem no mural de competências assim que o operador da plataforma as importar.',
      versions: 'Os formandos seguem {count} versões do regulamento – a cada um aplica-se a versão que estava em vigor no início da formação.',
    },
    state: {
      notSelectable: 'Já não pode ser selecionada',
      notSelectableHint: 'O operador da plataforma já não disponibiliza esta profissão para novas seleções. O teu espaço de trabalho mantém-na, com os seus formandos – mas, depois de a removeres, não pode voltar a ser adicionada.',
      withdrawn: 'Reconhecimento revogado',
      withdrawnHint: 'O reconhecimento estatal desta profissão foi revogado, ou esta já não consta do registo das profissões de formação reconhecidas. Os formandos em curso concluem a formação; não pode voltar a ser adicionada.',
      unknown: 'Não consta do catálogo',
      unknownHint: 'Esta entrada foi escrita antes de o catálogo existir e não corresponde a nenhuma das suas profissões. Só pode ser removida – adiciona em vez dela a profissão correspondente do catálogo.',
    },
    offered: {
      title: 'A nossa oferta',
      intro: 'As profissões de formação reconhecidas em que a tua empresa forma. Só estas podem ser escolhidas para um formando.',
      emptyTitle: 'Ainda não há nenhuma profissão de formação na oferta',
      empty: 'Escolhe no catálogo abaixo as profissões em que a tua empresa forma. Depois podes atribuí-las aos teus formandos.',
      browse: 'Escolher do catálogo',
      remove: 'Remover',
      removeNamed: 'Remover {title} da oferta',
    },
    catalogue: {
      title: 'Adicionar a partir do catálogo',
      intro: 'As profissões de formação reconhecidas na Alemanha que o teu espaço de trabalho ainda não oferece. O catálogo é mantido atualizado de forma centralizada.',
      unavailableTitle: 'O catálogo não está acessível neste momento',
      unavailable: 'A tua oferta acima é apresentada a partir do que este espaço de trabalho guardou. Será possível voltar a adicionar profissões assim que o catálogo estiver de volta.',
      allOffered: 'O teu espaço de trabalho já oferece todas as profissões do catálogo.',
      searchPlaceholder: 'Título ou especialização',
      areaLabel: 'Área',
      areaAll: 'Todas as áreas',
      count: 'Profissões encontradas: {shown} de {total}',
      noMatches: 'Nenhuma profissão corresponde à tua pesquisa.',
      resetFilters: 'Limpar a pesquisa',
      showMore: 'Mostrar mais',
      add: 'Adicionar',
      addNamed: 'Adicionar {title} à oferta',
    },
    removeConfirm: {
      title: 'Remover «{title}» da oferta?',
      apprentices: 'Formandos atualmente associados a esta profissão: {count}. Mantêm a sua profissão e concluem a formação – apenas deixa de poder ser escolhida para novos formandos.',
      final: 'Depois de removida, esta profissão não pode voltar a ser adicionada.',
      confirm: 'Remover da oferta',
    },
    toast: {
      added: '«{title}» faz agora parte da tua oferta',
      removed: '«{title}» já não é oferecida',
    },
    errors: {
      notOfferable: 'Não foi possível adicionar «{title}»: a profissão foi entretanto desativada ou revogada. A lista foi atualizada.',
      catalogueUnavailable: 'O catálogo não está acessível neste momento, pelo que não é possível adicionar nada. Tenta novamente mais tarde.',
    },
    page: {
      moduleInactiveTitle: 'A Formação não está ativa neste espaço de trabalho',
      moduleInactive: 'As profissões de formação são oferecidas aos formandos geridos no módulo Formação. Quando este fizer parte deste espaço de trabalho, é aqui que escolhes em que profissões a tua empresa forma.',
      noAccess: 'Não podes gerir as profissões de formação deste espaço de trabalho. Podem fazê-lo o proprietário do espaço de trabalho, a administração de suite e os membros do módulo Formação com permissão para o gerir.',
    },
  },
};
